export default {
    "goods_category_page_title": "商品分類",
    "goods_category_product": "商品",
    "goods_category_default": "默認",
    "goods_category_sales": "銷量",
    "goods_category_filter_brand": "篩選品牌",
    "goods_category_brand": "品牌",
    "goods_category_sub_brand": "子品牌",
    "goods_category_reset": "重置",
    "goods_category_confirm": "確認",
    "goods_category_retry": "重新載入",
    "goods_category_page_load_failed": "商品分類載入失敗",
    "goods_category_child_load_failed": "子分類載入失敗",
    "goods_category_brand_load_failed": "品牌載入失敗",
    "goods_category_goods_load_failed": "商品載入失敗",
    "goods_category_empty_category": "暫無商品分類",
    "goods_category_empty_category_desc": "請稍後再試",
    "goods_category_empty_child": "暫無子分類",
    "goods_category_empty_goods": "暫無商品",
    "goods_category_empty_goods_desc": "試試其他分類或品牌",
    "goods_category_load_more_failed": "載入失敗，點擊重試",
    "goods_category_no_more": "已載入全部商品",
    "goods_category_promotion_price": "促銷價",
    "goods_category_tomo_price": "TOMO價",
    "just_a_bit": "一下吧",
    "not_damaged_at_all": "一點沒損壞",
    "level_1_category": "一級分類",
    "lets_browse_shop_together": "一起逛逛這家店吧",
    "one_click_bind": "一鍵綁定",
    "seven_day_lord": "七日領主",
    "ten_thousand": "萬",
    "ten_thousand_yuan": "萬元",
    "mixc_mall": "萬象城",
    "three_weeks_full_attendance": "三周全勤鑄就不朽功績",
    "three_days_company": "三日相伴",
    "three_days_company_reward": "三日相伴收穫頗豐",
    "context": "上下文",
    "uploading": "上傳中",
    "uploading_mask": "上傳中蒙層",
    "upload_voucher": "上傳憑證",
    "upload_face_image_failed": "上傳刷臉圖片失敗",
    "upload_response_format_error": "上傳響應格式錯誤",
    "upload_after_sales_desc_hint": "上傳售後描述有助處理問題",
    "upload_image": "上傳圖片",
    "upload_failed": "上傳失敗",
    "upload_id_card_hint": "上傳身份證可自動識別資訊",
    "upload_unknown_error": "上傳過程中發生未知錯誤",
    "upload_bank_card_hint": "上傳銀行卡可自動識別資訊",
    "pull_up_to_load_more": "上拉加載更多",
    "shanghai_city": "上海市",
    "next_step": "下一步",
    "next_step_button": "下一步按鈕",
    "order_time": "下單時間",
    "download": "下載",
    "downloading": "下載中",
    "download_all_images_and_copy_info": "下載全部商品圖並複製商品資訊",
    "download_all_button": "下載全部按鈕",
    "download_to_album": "下載到相冊",
    "download_not_implemented": "下載功能暫未實現",
    "after_download": "下載後",
    "download_product_image": "下載商品圖",
    "download_images_publish_hint": "下載商品圖和商品資訊發布自己的平臺",
    "download_image_failed": "下載圖片失敗",
    "download_url_not_configured": "下載地址未配置",
    "download_url_config_loaded": "下載地址配置加載成功",
    "download_url_config_updated": "下載地址配置已更新",
    "download_failed": "下載失敗",
    "download_success": "下載成功",
    "download_button": "下載按鈕",
    "download_poster": "下載海報",
    "download_poster_share_moment": "下載海報發布朋友圈",
    "download_poster_button": "下載海報按鈕",
    "download_certificate": "下載證書",
    "download_timeout": "下載超時",
    "download_territory": "下載領地",
    "download_territory_code": "下載領地碼",
    "not_just_joining": "不只是加入",
    "no_decimals_allowed": "不可以輸入小數",
    "cannot_close": "不可關閉",
    "disagree": "不同意",
    "refund_not_supported": "不支持退款",
    "show_none_selected": "不顯示任何已選擇",
    "cannot_select_more_than": "不能選擇超過",
    "unlimited": "不限",
    "unlimited_people": "不限人數",
    "unlimited_stock": "不限庫存",
    "distributor_scroll_list": "與分銷員滾動列表",
    "exclusive_task": "專屬任務",
    "exclusive_params": "專屬參數",
    "exclusive_digital_space": "專屬數字空間",
    "exclusive_identity": "專屬身份",
    "exclusive_identity_badge": "專屬身份標識",
    "and_agree_to_protocols": "且代表您已同意以下協議",
    "and_allow_comments": "且允許注釋",
    "business_metrics": "業務指標",
    "justify_between": "兩邊定位",
    "strictly_selected_goods": "嚴選好物",
    "count_unit": "個",
    "events_count": "個事件",
    "personal": "個人",
    "personal_center": "個人中心",
    "personal_updates": "個人動態",
    "personal_contribution": "個人貢獻值",
    "personal_contribution_detail": "個人貢獻值明細",
    "personal_contribution_desc": "個人貢獻值說明",
    "personal_assets": "個人資產",
    "tasks_count": "個任務",
    "products_count": "個商品",
    "after_sales_reason_required": "個商品的售後理由不能為空",
    "product_status_required": "個商品的貨物狀態不能為空",
    "refund_amount_required": "個商品的退款金額不能為空",
    "refund_amount_format_error": "個商品的退款金額格式不正確",
    "signature": "個性簽名",
    "digital_assets_pending": "您有{count}個數字資產待領取",
    "merchant_audit_failed_msg": "很遺憾, 你的商家認證審核未通過, 原因如下：",
    "store_audit_failed_msg": "很遺憾, 你的門店認證審核未通過, 原因如下：",
    "merchant_audit_success_msg": "恭喜，你的商家認證審核已通過",
    "store_join_success_msg": "恭喜，你的門店已入駐領地",
    "if_join_store_guide": "如果你需要入駐門店，請點擊下方按鈕進行操作。",
    "store_manage_guide": "你可通過微信搜索“領地聯營”小程式,輸入短信中的用戶名與密碼,進行門店管理。",
    "digital_wallet_guide": "點擊下方按鈕，開通數字錢包，即可免費領取數字資產，享受專屬權益",
    "explore_new_world_msg": "快去領地探索新世界吧~",
    "gift_check_guide": "{content}，點擊下方按鈕查看",
    "download_to_join_msg": "下載領地App，持有數字商品，即可加入",
    "activities_count": "個活動",
    "red_packets_total": "個紅包共",
    "territory_members_holding_this": "個領地成員持有該",
    "territory_members_holding_asset": "個領地成員持有該數字資產",
    "taiwan_residents": "中國臺灣居民",
    "mainland_residents": "中國大陸居民",
    "macau_residents": "中國澳門居民",
    "cmcc_auth_terms": "中國移動認證服務條款",
    "hongkong_residents": "中國香港居民",
    "mapped_to_in": "中映射為",
    "not_found_in": "中沒有找到",
    "middle_section": "中部區域",
    "configured_in": "中配置",
    "center": "中間",
    "center_bump": "中間一個鼓包",
    "center_text_info": "中間文本資訊",
    "center_bulge": "中間鼓包",
    "temp_closed": "臨時閉店",
    "protect_rights": "為保障你的合法權益",
    "protect_your_rights": "為保障您的權益",
    "protect_account_assets": "為保障您的賬戶與資產安全",
    "convenience_for_developers": "為方便更多開發者使用",
    "main_dist_detail": "主分銷詳情",
    "main_image_area": "主圖片區域",
    "main_dist_product_detail": "主態分銷商品詳情",
    "main_dist_detail_short": "主態分銷商詳",
    "main_content": "主要內容",
    "main_content_area": "主要內容區域",
    "main_notice_bar": "主通知欄",
    "home_page": "主頁",
    "report": "舉報",
    "report_success": "舉報成功",
    "event_queued": "事件已加入隊列",
    "event_sent": "事件已發送",
    "event_passed": "事件通過",
    "event_retry": "事件重試",
    "event_retry_limit": "事件重試次數已達上限",
    "qrcode": "二維碼",
    "qrcode_saved": "二維碼保存成功",
    "qrcode_content_required": "二維碼內容不能為空",
    "qrcode_area": "二維碼區域",
    "qrcode_desc": "二維碼描述",
    "qrcode_display_area": "二維碼顯示區域",
    "qrcode_generating": "二維碼生成中",
    "yunnan_signboard": "雲南招牌",
    "yunnan_restaurant_available": "雲南精選餐廳可用",
    "mutual_follow_action": "互關",
    "interaction_data_row": "互動數據行",
    "mutual_follow": "互相關注",
    "five_star_rating": "五星好評",
    "transaction_list": "交易列表",
    "transaction_no": "交易單號",
    "transaction_cancelled": "交易取消",
    "transaction_count": "交易數量",
    "enjoy_exclusive_rights": "享受專屬權益",
    "person": "人",
    "people_distributed": "人分銷過",
    "people_participated": "人參加",
    "people_collaborated": "人合作過",
    "personnel_list_container": "人員列表容器",
    "people_consulted": "人諮詢過",
    "people_online": "人在線",
    "people_joined": "人已加入",
    "people_registered": "人已報名",
    "people_holding": "人已持有",
    "people_brought": "人帶過",
    "people_hold": "人持有",
    "people_chatting": "人正在熱聊",
    "people_operating": "人正在聯營",
    "connections": "人脈",
    "connection_coorperation": "人脈合作",
    "connection_skills": "人脈技能",
    "face_auth": "人臉認證",
    "face_verify_success": "人臉驗證成功",
    "people_earned_commission": "人獲得傭金",
    "people_liked_post": "人讚了你的動態",
    "people_liked_comment": "人讚了你的評論",
    "people_booked": "人預約",
    "people_dining": "人餐",
    "what_is_contribution": "什麼是個人貢獻值",
    "what_is_digital_assets": "什麼是數字權益資產",
    "what_is_estimated_commission": "什麼是預估傭金",
    "left_nothing": "什麼都沒有留下",
    "fallback_only": "僅作為回退",
    "only_left": "僅剩",
    "wechat_only_and": "僅在微信內且",
    "button_only": "僅按鈕",
    "refund_only": "僅退款",
    "today": "今天",
    "today_purchasable": "今日可購買",
    "today_purchase_limit_reached": "今日可購買次數已用完",
    "today_earnings": "今日收益",
    "today_order": "今日第",
    "today_checkin_reward": "今日簽到獎勵",
    "today_invite_count": "今日邀請人數",
    "intro_no_politics": "介紹中請勿含有涉及政治",
    "from": "從",
    "from_own_showcase": "從自己的櫥窗",
    "transparent_to_black": "從透明到黑色",
    "territories_he_joined": "佢加入的領地",
    "digital_assets_he_holds": "佢持有的數字資產",
    "payment_time": "付款時間",
    "help_fill_logistics": "代填寫物流資訊",
    "voucher": "代金券",
    "voucher_product": "代金券商品",
    "following": "以下",
    "following_content_depend_on": "以下內容請根據選擇的",
    "dashboard": "儀表盤",
    "piece": "件",
    "items_product": "件商品",
    "value": "價值",
    "value_burst": "價值全面迸發",
    "price": "價格",
    "price_info": "價格資訊",
    "price_info_card": "價格資訊卡片",
    "price_area": "價格區域",
    "price_and_quantity": "價格和數量",
    "price_number": "價格數字",
    "price_display": "價格顯示",
    "task": "任務",
    "place_to_win_attention": "任務就能贏得眾人矚目的地方",
    "task_square": "任務廣場",
    "portion": "份",
    "discount_info": "優惠資訊",
    "coupon": "優惠券",
    "coupon_info": "優惠券資訊",
    "coupon_content": "優惠券內容",
    "coupon_list": "優惠券列表",
    "coupon_tag": "優惠券標籤",
    "member": "會員",
    "member_operation_desc": "會員運營沉澱流量資產管道分銷驅動復購增長",
    "everyday_at": "會喺每日",
    "recommend_to_friend": "會推薦俾朋友",
    "bit": "位",
    "above_separator": "位於分割線上方",
    "member_count_unit": "位成員",
    "digit_verification_code": "位數字驗證碼",
    "location": "位置",
    "low_price_recharge_scam": "低價充值等言論",
    "experience": "體驗",
    "merchants_available": "餘家商戶可用",
    "balance": "餘額",
    "balance_display": "餘額顯示",
    "author": "作者",
    "author_reply": "作者回覆",
    "author_liked": "作者讚過",
    "search_via_wechat": "你可通過微信搜索",
    "hello": "你好",
    "level_image_cool": "你的專屬等級形象就越炫酷",
    "identity_badge_display": "你的專屬身份標識將直接顯示在你的頭像旁",
    "merchant_auth_approved": "你的商家認證審核已通過",
    "merchant_auth_rejected": "你的商家認證審核未通過",
    "friend_shared_post": "你的好友分享了一篇領地動態",
    "digital_identity_waiting": "你的數字身份正在等你認領",
    "every_participation": "你的每一次參與",
    "every_contribution_convert": "你的每一次貢獻都會轉化為",
    "store_joined_territory": "你的門店已入駐領地",
    "store_auth_rejected": "你的門店認證審核未通過",
    "commission": "傭金",
    "commission_card": "傭金卡片",
    "commission_price_row": "傭金和價格行",
    "commission_data": "傭金數據",
    "commission_rate": "傭金率",
    "higher_commission": "傭金越高",
    "wear": "佩戴",
    "wear_success": "佩戴成功",
    "use": "使用",
    "use_main_image_as_thumb": "使用商品主圖作為縮略圖",
    "use_time": "使用時間",
    "usage_process": "使用流程",
    "usage_rules": "使用規則",
    "usage_record": "使用記錄",
    "usage_instructions": "使用說明",
    "usage_notice": "使用須知",
    "use_default_config": "使用默認配置",
    "promotion": "促銷",
    "promotion_activity": "促銷活動",
    "save": "保存",
    "saving": "保存中",
    "save_image": "保存圖片",
    "save_failed": "保存失敗",
    "save_avatar": "保存頭像",
    "save_success": "保存成功",
    "save_to_album": "保存至相冊",
    "secret": "保密",
    "info_area": "資訊區域",
    "info_error": "資訊有誤",
    "modify": "修改",
    "modify_after_sales_apply": "修改售後申請",
    "modify_after_sales_submitted": "修改售後申請已提交",
    "modify_failed": "修改失敗",
    "modify_account_info": "修改開戶資訊",
    "modify_success": "修改成功",
    "modify_address": "修改收貨地址",
    "modify_nickname": "修改暱稱",
    "modify_tags": "修改標籤",
    "modify_application": "修改申請",
    "modify_signature": "修改簽名",
    "modify_profile": "修改資料",
    "modify_territory_name": "修改領地名稱",
    "countdown": "倒計時",
    "parking": "停車",
    "yuan": "$",
    "yuan_all_category_voucher": "元全品類代金券",
    "yuan_available": "$可用",
    "full_energy_checkin": "$氣滿滿來簽到了",
    "element": "元素",
    "yuan_red_packet_await": "$紅包與專屬權益等你來拿",
    "yuan_dining_voucher": "$餐飲通用券",
    "recharge": "充值",
    "confirm_age_before_recharge": "充值前請確認已滿",
    "recharge_protocol_hint": "充值協議提示",
    "recharge_failed": "充值失敗",
    "recharge_exception": "充值異常",
    "recharge_success": "充值成功",
    "recharge_button": "充值按鈕",
    "recharge_buffer_time_hint": "充值購買需要緩衝時間",
    "recharge_options_grid": "充值選項網格",
    "recharge_diamond": "充值領鑽",
    "delete_one_first": "先刪除一個吧",
    "served_first": "先到先得",
    "free": "免費",
    "no_reservation_needed": "免預約",
    "join_store": "入駐門店",
    "nationwide_chain": "全連鎖",
    "available_all_day": "全天可用",
    "fullscreen_overlay": "全屏覆蓋顯示",
    "store_wide_use": "全店通用",
    "visible_to_all_users": "全站用戶都能看到",
    "select_all": "全選",
    "all": "全部",
    "all_products": "全部商品",
    "all_combos": "全部套餐",
    "all_shops": "全部店舖",
    "withdraw_all": "全部提現",
    "all_messages": "全部消息",
    "all_orders": "全部訂單",
    "all_stores": "全部門店",
    "public_channel": "公共頻道",
    "company": "公司",
    "km": "公里",
    "total": "共",
    "total_discount": "共優惠",
    "total_profit_share": "共分潤",
    "boost_brand_value_together": "共同提升品牌價值",
    "governance_profit_share": "共治分潤",
    "total_saved": "共省",
    "about_us": "關於我們",
    "about_territory": "關於領地",
    "follow": "關注",
    "followed_you": "關注了你",
    "follow_success": "關注成功",
    "follow_button": "關注按鈕",
    "follow_messages": "關注消息",
    "follow_related": "關注相關",
    "relation_graph_area": "關係圖區域",
    "relation_graph_canvas": "關係圖畫布",
    "close": "關閉",
    "close_button": "關閉按鈕",
    "interest_tags": "興趣標籤",
    "others": "其他",
    "other_country_residents": "其他國家或地區居民",
    "other_icons_list": "其他圖標列表",
    "other_miniapps_via": "其他小程式通過",
    "others_unchanged": "其他我沒改",
    "login_other_phone": "其他手機號登錄",
    "other_share_page_types": "其他類型的分享頁面",
    "other_rules": "其他規則",
    "other_pages_no_setting": "其他頁面不需要設置",
    "compatible": "相容",
    "content": "內容",
    "content_empty": "內容為空",
    "content_unchanged": "內容保持不變",
    "content_share_card": "內容分享卡片",
    "content_area": "內容區域",
    "content_card_template": "內容卡片範本",
    "content_customizable": "內容可自定義",
    "content_and_comments": "內容和評論",
    "content_image": "內容圖片",
    "content_cover": "內容封面",
    "content_layer": "內容層",
    "content_box": "內容盒子",
    "content_details": "內容詳情",
    "content_part": "內容部分",
    "even_the_smallest_individual": "再小的個體",
    "order_again": "再來一單",
    "verify_again": "再次認證",
    "try_again": "再試一次",
    "minus": "減",
    "top_seller": "出單達人",
    "minute": "分",
    "share": "分享",
    "sharing": "分享中",
    "share_to_miniapp_failed": "分享到微信小程式失敗",
    "share_card": "分享卡片",
    "share_card_failed": "分享卡片失敗",
    "share_monetization": "分享變現",
    "share_product": "分享商品",
    "share_failed": "分享失敗",
    "share_miniapp_card_image": "分享小程式卡片主圖",
    "share_guide_modal": "分享引導彈窗",
    "share_modal": "分享彈窗",
    "share_modal_component": "分享彈窗組件",
    "share_wechat": "分享微信",
    "share_button": "分享按鈕",
    "share_button_area": "分享按鈕區域",
    "share_moments": "分享朋友圈",
    "share_poster": "分享海報",
    "share_component": "分享組件",
    "share_interesting_user": "分享給你一個超有趣的領地用戶",
    "share_to_friends": "分享給好友",
    "share_to": "分享至",
    "share_earn_money": "分享賺錢",
    "divider": "分割線",
    "split_percentage": "分成",
    "analyzing_image_color": "分析圖片顏色中",
    "profit_share": "分潤",
    "category_selector": "分類選擇器",
    "group_button": "分組按鈕",
    "group_title": "分組標題",
    "minutes": "分鐘",
    "minutes_ago": "分鐘前",
    "sold_out_in_minutes": "分鐘被搶光",
    "distributor_list": "分銷員列表",
    "distributor_status": "分銷員狀態",
    "distributor_level": "分銷員等級",
    "distributor_product_page": "分銷商品專用頁面",
    "distribute_group_buy": "分銷團購商品",
    "distribute_group_buy_detail": "分銷團購商品詳情",
    "distribute_group_detail": "分銷團購詳情",
    "distribute_earn_commission": "分銷得傭金",
    "distribute_max_earn": "分銷最高可賺",
    "distribution_module": "分銷模塊",
    "distribute_this_product": "分銷此商品",
    "distribute_retail_product": "分銷零售商品",
    "distribute_retail_product_detail": "分銷零售商品詳情",
    "separator": "分隔符號",
    "separator_line": "分隔線",
    "switch": "切換",
    "switch_failed": "切換失敗",
    "switch_nav": "切換導航",
    "switch_login": "退出登錄",
    "list": "列表",
    "just_now": "剛剛",
    "create": "創作",
    "creator": "創作者",
    "create_verb": "創建",
    "create_new_territory": "創建新領地",
    "create_time": "創建時間",
    "creator_noun": "創建者",
    "create_order_event": "創建訂單事件",
    "create_territory": "創建領地",
    "init_share_data_failed": "初始化分享數據失敗",
    "init_failed": "初始化失敗",
    "init_completed": "初始化完成",
    "init_config_params": "初始化配置參數",
    "delete": "刪除",
    "deleting": "刪除中",
    "delete_in_detail_page": "刪除功能請在詳情頁操作",
    "delete_post_warning": "刪除後此條動態在所有場景均消失",
    "delete_address": "刪除地址",
    "delete_success": "刪除成功",
    "free_gift_in_store": "到店消費可免費獲贈",
    "checkin_post_after_store_visit": "到店消費後發布動態打卡",
    "final_price": "到手價",
    "final_price_text": "到手價文字",
    "arrival_bank_card": "到賬銀行卡",
    "refresh_success": "刷新成功",
    "coupon_code": "券碼",
    "open_browser_paste": "前往瀏覽器粘貼並打開",
    "remaining": "剩餘",
    "remaining_stock": "剩餘庫存",
    "remaining_payment_time": "剩餘支付時間",
    "join": "加入",
    "add_to_showcase_failed": "加入櫥窗失敗",
    "add_to_cart": "加入購物車",
    "join_territory": "加入領地",
    "join_territory_interact": "加入領地與其他成員進行互動",
    "join_territory_pact": "加入領地公約",
    "join_territory_merchant_alliance": "加入領地商戶聯盟",
    "join_territory_success": "加入領地成功",
    "add_wechat_join_group": "加微信入群",
    "add_showcase": "加櫥窗",
    "loading": "加載",
    "loading_status": "加載中",
    "loading_failed": "加載失敗",
    "loading_hint": "加載提示",
    "load_more": "加載更多",
    "load_more_hint": "加載更多提示",
    "loading_state": "加載狀態",
    "loading_indicator": "加載狀態指示器",
    "add_selection_library": "加選品庫",
    "accelerate_brand_value": "加速自我品牌價值提升",
    "moments": "動態",
    "dynamic_recharge": "動態充值",
    "dynamic_param_trigger": "動態參數觸發",
    "dynamic_param_trigger_failed": "動態參數觸發失敗",
    "dynamic_param_trigger_completed": "動態參數觸發完成",
    "moment_posted": "動態發布成功",
    "moment_deleted": "動態已刪除",
    "moment_detail": "動態詳情",
    "moments_channel": "動態頻道",
    "animation_container": "動畫容器",
    "medal": "勳章",
    "wrap_container_for_animation": "包一層容器用於動畫",
    "well_packaged": "包裝嚴實",
    "exquisite_packaging": "包裝精緻",
    "free_shipping": "包郵",
    "beijing": "北京市",
    "beijing_territory": "北京領地",
    "craftsmanship": "匠心工藝",
    "district": "區",
    "district_county": "區縣",
    "district_list": "區縣列表",
    "district_level": "區縣級別",
    "blockchain_collection_certificate": "區塊鏈藏品證書",
    "blockchain_certificate": "區塊鏈證書",
    "area": "區域",
    "area_content": "區域內容",
    "area_chart": "區域圖",
    "ten_days_breakthrough": "十日堅持突破自我",
    "upgrade_identity": "升級身份",
    "half_year_sales": "半年售",
    "half_star": "半星",
    "halfway_champion": "半程桂冠",
    "negotiation_history": "協商歷史",
    "protocol_content": "協議內容",
    "protocol_check": "協議勾選",
    "protocol_modal": "協議彈窗",
    "single": "單",
    "single_avatar": "單個頭像",
    "single_amount": "單個金額",
    "sell_product_earn_commission": "賣出商品獲得傭金",
    "placeholder": "占位",
    "card_area": "卡片區域",
    "card_container": "卡片容器",
    "card_size": "卡片尺寸",
    "card_template": "卡片範本",
    "card_background": "卡片背景",
    "place_order_now": "即可下單",
    "claim_digital_asset_free": "即可免費領取數字資產",
    "join_now": "即可加入",
    "join_this_territory_now": "即可加入該領地",
    "join_territory_now": "即可加入領地",
    "open_digital_wallet_now": "即可開通數字錢包",
    "become_distributor_open_wallet": "即可成為分銷員並開通現金錢包",
    "reason": "原因",
    "reason_below": "原因如下",
    "original": "原始",
    "go_to_order": "去下單",
    "go_to_pay": "去付款",
    "go_to_use": "去使用",
    "go_to_recharge": "去充值",
    "go_to_share": "去分享",
    "go_share_moments": "去分享動態吧",
    "go_browse_elsewhere": "去別處逛逛吧~",
    "go_post": "去發帖",
    "go_activate": "去開通",
    "go_open": "去打開",
    "go_promote": "去推廣",
    "go_pay": "去支付",
    "go_update": "去更新",
    "go_view": "去查看",
    "go_like": "去點贊",
    "go_checkin": "去簽到",
    "go_settle": "去結算",
    "go_setting": "去設置",
    "go_comment": "去評論",
    "go_buy": "去購買",
    "go_gift": "去贈送",
    "go_invite": "去邀請",
    "go_claim": "去領取",
    "join_brand_alliance_earn": "參與品牌聯營並獲得收益",
    "join_alliance": "參與聯營",
    "participate": "參加",
    "params": "參數",
    "in_params": "參數中",
    "params_failed": "參數失敗",
    "params_error": "參數錯誤",
    "two_way_bind_search": "雙向綁定搜索值",
    "sent_red_packets": "發出的紅包",
    "post_moment": "發動態",
    "on_sale": "發售",
    "release_calendar": "發售日曆",
    "posted_at": "發布於",
    "post_button": "發布按鈕",
    "post_activity": "發布活動",
    "post_get_rewards_hint": "發帖有機會獲得更多獎勵哦",
    "post_show_off": "發帖炫耀一下",
    "send_danmu": "發彈幕",
    "post_service": "發服務",
    "post_event": "發活動",
    "invoice_apply": "發票申請",
    "send_red_packet": "發紅包",
    "issue": "發行",
    "issue_info": "發行資訊",
    "issue_platform": "發行平臺",
    "issuer": "發行方",
    "ship": "發貨",
    "shipping_origin": "發貨地",
    "fast_shipping": "發貨快",
    "initiate_and_host_success": "發起並成功舉辦",
    "send": "發送",
    "sending": "發送中",
    "send_location": "發送位置",
    "send_failed": "發送失敗",
    "send_exception": "發送異常",
    "send_success": "發送成功",
    "send_red_envelope": "發送紅包",
    "pick_a_loud_name": "取一個響亮的名稱吧",
    "cancel": "取消",
    "unequip": "取消佩戴",
    "unfollow": "取消關注",
    "unfollow_failed": "取消關注失敗",
    "unfollow_success": "取消關注成功",
    "unfollow_confirm_modal": "取消關注確認彈窗",
    "cancel_reason": "取消原因",
    "cancel_success": "取消成功",
    "cancel_button": "取消按鈕",
    "cancel_payment": "取消支付",
    "cancel_time": "取消時間",
    "unlike": "取消點贊",
    "cancel_reason_text": "取消理由",
    "cancel_remove": "取消移除",
    "unpin": "取消置頂",
    "cancel_order": "取消訂單",
    "cancel_order_failed": "取消訂單失敗",
    "cancel_order_success": "取消訂單成功",
    "pickup_time": "取貨時間",
    "monetize_revenue_sustainable": "變現收益持續化",
    "only_show": "只顯示",
    "select_one_video_only": "只能選擇一個視頻",
    "can_upload_multiple": "可上傳多張",
    "can_in": "可以在",
    "available": "可使用",
    "can_get_free": "可免費獲贈",
    "can_at": "可在",
    "withdrawable_amount": "可提現金額",
    "replaceable": "可替換",
    "add_content_as_needed": "可根據需要添加內容",
    "can_perform": "可演出",
    "available_alt": "可用",
    "available_time": "可用時間",
    "available_stores": "可用門店",
    "maybe_invalid": "可能不是有效的",
    "proxy_config_error_maybe": "可能代理配置錯誤",
    "can_obtain": "可獲得",
    "can_get_avatar_frame": "可獲得頭像框組件",
    "can_get_rewards": "可獲得獎勵",
    "can_earn": "可賺",
    "optional": "可選",
    "claim_initial_territory_medal": "可領取初始領地勳章",
    "claimable_rewards": "可領取獎勵",
    "taiwan_resident_pass": "臺灣居民證",
    "top_right_close_button": "右上角關閉按鈕",
    "right_side": "右側",
    "right_price_button": "右側價格按鈕",
    "right_content": "右側內容",
    "right_area": "右側區域",
    "right_icon": "右側圖標",
    "right_display": "右側展示",
    "right_invited_info": "右側已邀請信息",
    "right_button": "右側按鈕",
    "right_revenue_card": "右側收益曲線卡",
    "right_text_part": "右側文字部分",
    "right_column": "右列",
    "number": "號",
    "cooperation_location": "合作地點",
    "cooperation_square": "合作廣場",
    "cooperation_poster": "合作海報",
    "cooperation_detail": "合作詳情",
    "hopson_one": "合生匯",
    "total_sum": "合計",
    "same_day_available": "同一到同日可用",
    "agree_protocol_register": "同意協議並註冊",
    "agree_recharge": "同意並充值",
    "agree_continue": "同意並繼續",
    "peers": "同行",
    "no_politics_in_name": "名稱中請勿含有涉及政治",
    "name_tags_area": "名稱和標籤區域",
    "people_checked_in": "名簽到",
    "after": "後",
    "apply_after_sales_again_after": "後再次申請售後",
    "merchant_not_confirm_after_reapply": "後再次申請售後商家未確認",
    "merchant_not_confirm_after": "後商家未確認",
    "merchant_not_refund_after": "後商家未退款",
    "return_prev_page_after": "後將返回上級頁面",
    "open_after": "後開啟",
    "revoke_return_if_not_shipped_after": "後未寄出將撤銷退貨申請",
    "potential_refund_later": "後續用戶可能存在退款情況",
    "auto_close_after": "後自動關閉",
    "upward_gradient_shadow": "向上漸變陰影",
    "show_code_to_merchant": "向商家出示二維碼或券號即可消費",
    "question_mark": "嗎",
    "else_show_back_arrow": "否則顯示返回箭頭",
    "startup_success": "啟動成功",
    "bottom_cancel_button": "吸低取消按鈕",
    "monday": "週一",
    "wednesday": "週三",
    "tuesday": "週二",
    "friday": "週五",
    "saturday": "週六",
    "thursday": "週四",
    "years_old": "週歲",
    "sunday": "週日",
    "and": "和",
    "and_miniapp": "和小程式",
    "unified_with_miniapp": "和小程式統一使用",
    "coffee_lover": "咖啡星人",
    "brand_intro": "品牌介紹",
    "brand_collab_opportunity": "品牌共建機會",
    "brand_recommender": "品牌推薦官",
    "brand_apply_collab": "品牌申請合作",
    "after_sales_processing": "售後中",
    "after_sales_desc": "售後資訊描述",
    "after_sales_info_modal": "售後資訊選擇彈窗",
    "after_sales_no": "售後單號",
    "after_sales_product_modal": "售後商品選擇彈窗",
    "after_sales_button": "售後按鈕",
    "after_sales_description": "售後描述",
    "after_sales_desc_input_modal": "售後描述輸入彈窗",
    "worry_free_after_sales": "售後無憂",
    "after_sales_status_hint": "售後狀態提示",
    "after_sales_reason": "售後理由",
    "after_sales_reason_modal": "售後理由選擇彈窗",
    "after_sales_apply_failed": "售後申請失敗",
    "after_sales_apply_submitted": "售後申請已提交",
    "after_sales_type": "售後類型",
    "after_sales_detail": "售後詳情",
    "after_sales_options": "售後選項",
    "product": "商品",
    "product_info": "商品資訊",
    "product_info_incomplete": "商品資訊不完整",
    "product_info_area": "商品資訊區域",
    "product_info_card": "商品資訊卡片",
    "product_info_error": "商品資訊異常",
    "product_share_card": "商品分享卡片",
    "product_list": "商品列表",
    "product_card": "商品卡片",
    "product_card_template": "商品卡片範本",
    "product_name": "商品名稱",
    "product_image_list": "商品圖列表",
    "product_image": "商品圖片",
    "product_image_area": "商品圖片區域",
    "product_image_carousel": "商品圖片輪播",
    "product_basic_info": "商品基本資訊",
    "product_off_shelf": "商品已下架",
    "product_invalid": "商品已失效",
    "product_quantity": "商品數量",
    "product_quantity_min": "商品數量不能再少了",
    "product_exposure": "商品曝光",
    "product_tags": "商品標籤",
    "product_title": "商品標題",
    "product_grid": "商品網格",
    "product_specs": "商品規格",
    "product_detail": "商品詳情",
    "product_amount": "商品金額",
    "merchant": "商家",
    "merchant_name": "商家名稱",
    "merchant_invite_user": "商家拉用戶",
    "merchant_reject": "商家拒絕",
    "merchant_rejected_after_sales": "商家拒絕了您的售後申請",
    "merchant_rejected_refund": "商家拒絕退款",
    "merchant_no_product_yet": "商家暫未上架商品",
    "merchant_auth": "商家認證",
    "merchant_invited_merchant": "商家邀請的商家",
    "merchant_invited_user": "商家邀請的用戶",
    "business": "商戶",
    "business_name": "商戶名稱",
    "business_location": "商戶所在地",
    "business_invite_card": "商戶邀請卡片",
    "business_territory": "商戶領地",
    "sichuan": "四川省",
    "follow_back": "回關",
    "back_to_map": "回到地圖",
    "back_to_map_button": "回到地圖按鈕",
    "back_to_territory": "回到領地",
    "reply": "回復",
    "replied_your_comment": "回覆了你的評論",
    "reply_success": "回覆成功",
    "reply_comment": "回覆評論",
    "reply_input": "回覆輸入框",
    "callback_failed": "回調函數執行失敗",
    "group": "團",
    "group_buy": "團購",
    "group_buy_coupon": "團購券",
    "group_buy_center": "團購券中心",
    "group_buy_product_detail": "團購券商品詳情",
    "group_buy_detail": "團購券詳情",
    "group_buy_product": "團購商品",
    "group_buy_product_detail_alt": "團購商品詳情",
    "group_buy_combo": "團購套餐",
    "group_buy_write_off": "團購核銷",
    "group_buy_detail_alt": "團購詳情",
    "team_admin": "團隊管理員",
    "fixed": "固定",
    "fix_use_first_image": "固定使用第一張圖片",
    "fix_at_top": "固定在頂部",
    "fixed_size": "固定寬高",
    "tabbar_home": "領地",
    "tabbar_mall": "商城",
    "tabbar_activity": "活動",
    "tabbar_me": "我的",
    "events_plaza": "活動廣場",
    "all_activities": "全部活動",
    "same_city": "同城",
    "hot": "熱門",
    "no_activities": "暫無活動",
    "signup_success_msg": "恭喜報名活動成功, 請按時參與活動，可在【我的】-【我的活動】查看詳情",
    "search_placeholder_fun": "領地真好玩",


    "fixed_term": "固定期限",
    "icon": "圖標",
    "image": "圖片",
    "image_upload_area": "圖片上傳區域",
    "image_load_failed": "圖片加載失敗",
    "image_area": "圖片區域",
    "image_saved_to_album": "圖片已保存到相冊",
    "image_data_empty": "圖片數據為空",
    "image_count_badge": "圖片數量標識",
    "image_index_indicator": "圖片索引指示器",
    "image_crop_failed": "圖片裁剪失敗",
    "image_counter": "圖片計數器",
    "image_carousel_alt": "圖片輪播",
    "arc_progress_bar": "圓弧進度條",
    "ring_chart": "圓環圖",
    "rounded_corners": "圓角",
    "tuqi_group_made": "土氣集團土氣製造",
    "at": "在",
    "online_status": "在線狀態",
    "in_territory": "在領地",
    "follow_find_me_in_territory": "在領地關注並找到我",
    "region": "地區",
    "region_selector": "地區選擇器",
    "region_picker_modal": "地區選擇彈窗",
    "map": "地圖",
    "map_load_failed": "地圖加載失敗",
    "map_container": "地圖容器",
    "address_info": "地址資訊",
    "modify_address_alt": "地址修改",
    "switch_address_delivery": "地址和配送方式切換",
    "select_address_delivery": "地址和配送方式選擇",
    "address_management": "地址管理",
    "address_type": "地址類型",
    "offline_gathering": "場線下聚會",
    "city": "城市",
    "city_list": "城市列表",
    "city_level": "城市級別",
    "base_init_completed": "基礎初始化完成",
    "fill_tracking_no": "填寫單號",
    "fill_account_info": "填寫開戶資訊",
    "fill_shipping_address": "填寫收貨地址",
    "fill_id_info": "填寫證件資訊",
    "fill_return_logistics": "填寫退貨物流",
    "process": "處理",
    "processing": "處理中",
    "handle_yyb_download": "處理應用寶下載",
    "handle_honor_download": "處理榮耀設備下載",
    "backup": "備",
    "icp_license": "備案號",
    "backup_tag_failed": "備用標籤失敗",
    "backup_tag_success": "備用標籤成功",
    "copy": "複製",
    "copy_usage_comment": "複製使用請保留本段註釋",
    "copy_failed": "複製失敗",
    "copy_miniapp_link_failed": "複製小程式鏈接失敗",
    "copy_success": "複製成功",
    "copy_invite_code": "複製邀請碼",
    "copy_invite_code_failed": "複製邀請碼失敗",
    "copy_link": "複製鏈接",
    "copy_territory_link_download": "複製領地鏈接下載",
    "delivery_available": "外賣可用",
    "foreigner_residence_permit": "外國人居留證",
    "outer_container": "外層容器",
    "outer_container_style": "外層容器控制最大最小高度和背景填充",
    "takeout": "外帶",
    "multiple_avatars": "多個頭像",
    "greater_than": "大於",
    "lucky_prosperous": "大吉大利",
    "day": "天",
    "valid_within_days": "天內有效",
    "days_ago": "天前",
    "expire_after_days": "天後到期",
    "valid_after_days": "天後有效",
    "daily_checkin": "天天簽到",
    "daily_checkin_reward": "天天簽到領獎勵",
    "day_reward": "天獎勵",
    "day_revenue_curve": "天收益曲線",
    "days_count": "天數",
    "days_valid": "天有效",
    "tianjin_city": "天津市",
    "scorpio": "天蠍座",
    "sold_out_in_days": "天被搶光",
    "suncode_load_failed": "太陽碼加載失敗",
    "suncode_display_area": "太陽碼展示區域",
    "suncode_loading": "太陽碼未加載完成",
    "invalid": "失效",
    "invalid_product": "失效商品",
    "invalid_status_icon": "失效狀態圖標",
    "invalid_status_mask": "失效狀態遮罩",
    "failed": "失敗",
    "avatar": "頭像",
    "avatar_info": "頭像資訊",
    "avatar_stroke": "頭像描邊",
    "avatar_update_failed": "頭像更新失敗",
    "avatar_not_loaded": "頭像未加載",
    "avatar_frame": "頭像框",
    "avatar_frame_display": "頭像框展示",
    "avatar_frame_buy_modal": "頭像框購買彈窗",
    "avatar_section": "頭像部分",
    "header_image_area": "頭圖區域",
    "header": "頭部",
    "header_bg_image": "頭部背景圖",
    "reward_modal": "獎勵彈窗",
    "female": "女",
    "friend_buys_you_earn": "好友買你掙錢",
    "praise": "好評",
    "praise_rank": "好評榜",
    "if_example": "如",
    "submit_gitee_if_suggestion": "如有更好的建議請提交碼雲",
    "if_need_join_store": "如果你需要入駐門店",
    "if_has": "如果有",
    "if_has_input": "如果有輸入內容",
    "if_no_input": "如果沒有輸入內容",
    "invoice_contact_offline": "如需開據發票請線下聯繫商舖工作人員",
    "full_name": "姓名",
    "submenu_list": "子菜單列表",
    "font_loading_completed_alt": "字體加載完成",
    "font_loading_mask": "字體加載遮罩",
    "string_format": "字串格式",
    "full_replace": "完全替代",
    "complete_avatar": "完善頭像",
    "complete_account_info": "完善開戶資訊",
    "complete_shipping_address_hint": "完善您的收貨地址",
    "complete_shipping_address": "完善收貨地址",
    "completed": "完成",
    "complete_below_actions": "完成下方操作",
    "after_realname_auth": "完成實名認證後",
    "completion_rate": "完成率",
    "full_init_completed": "完整初始化完成",
    "full_modal": "完整彈窗",
    "full_ranking": "完整榜單",
    "official": "官方",
    "official_website": "官方網站",
    "positioning": "定位",
    "positioning_failed": "定位失敗",
    "positioning_success": "定位成功",
    "positioning_placeholder": "定位時的占位元素",
    "actual_payment": "支付金額",
    "physical_group_buy_detail": "實體團購詳情",
    "physical_retail_detail": "實體零售詳情",
    "live_photo": "實況",
    "realname_auth": "實名認證",
    "solid_star": "實心星",
    "realtime_selected_time": "實時顯示當前選中的時間",
    "realtime_speed": "實時速度",
    "physical": "實物",
    "physical_coupon": "實物券",
    "physical_goods": "實物商品",
    "physical_group_goods": "實物團購商品",
    "physical_retail_goods": "實物零售商品",
    "implement_pull_refresh_load": "實現下拉刷新和上拉加載",
    "auditing": "審核中",
    "audit_result_notify": "審核結果會以系統消息進行通知",
    "customer_service": "客服",
    "customer_service_card": "客服卡片",
    "family": "家",
    "capacity_select": "容量選擇",
    "corresponding_benefits": "對應權益",
    "object_empty": "對象為空",
    "navigation": "導航",
    "nav_position_error": "導航位置錯誤",
    "nav_failed": "導航失敗",
    "navbar": "導航欄",
    "navbar_main": "導航欄主體",
    "navbar_content_area": "導航欄內容區域",
    "will_at": "將於",
    "will_use": "將使用",
    "will_auto_agree_after_sales": "將自動同意售後",
    "will_auto_refund": "將自動退款",
    "will_auto_refund_to_you": "將自動退款給您",
    "small_avatar": "小頭像",
    "hour": "小時",
    "ship_within_hours": "小時內發貨",
    "hours_ago": "小時前",
    "expire_after_hours": "小時後到期",
    "refund_after_hours": "小時後發起退款",
    "sold_out_in_hours": "小時被搶光",
    "miniapp": "小程式",
    "miniapp_dedicated": "小程式專用",
    "miniapp_code": "小程式碼",
    "miniapp_link_empty": "小程式鏈接為空",
    "miniapp_link_copied": "小程式鏈接已複製到剪貼板",
    "miniapp_color_extract_failed": "小程式顏色提取失敗",
    "miniapp_color_extract_incomplete": "小程式顏色提取暫未完全實現",
    "try_further_batching": "嘗試進一步分批",
    "try_downgrade": "嘗試降級方案",
    "claim_limited_identity_hint": "就可領取限量領地數字身份",
    "render_open_tag_when_ready": "就緒後渲染開放標籤",
    "game_round": "局",
    "local_care": "局部護理",
    "floor_food_court": "層美食城",
    "expand": "展開",
    "expand_collapse_button": "展開收起按鈕",
    "expand_more_button": "展開更多按鈕",
    "show_bottom_button_placeholder": "展示底部按鈕占位",
    "attr_show_search_box": "屬性顯示搜索框",
    "attr_add_fixed_class_style": "屬性添加固定定位類合併後的樣式",
    "attr_set_home": "屬性設置首頁",
    "mountain_chart": "山峰圖",
    "left_side": "左側",
    "left_area": "左側區域",
    "left_brand_card": "左側品牌卡",
    "left_product_thumb": "左側商品縮略圖",
    "left_image": "左側圖片",
    "left_avatar": "左側頭像",
    "left_hint_text": "左側提示文本",
    "left_amount": "左側金額",
    "left_column": "左列",
    "uploaded_images": "已上傳的圖片",
    "off_shelf": "已下架",
    "order_generated": "已為您生成交易訂單",
    "order_generated_simple": "已為您生成訂單",
    "paid": "已付款",
    "used": "已使用",
    "used_status": "已使用狀態",
    "followed": "已關注",
    "closed": "已關閉",
    "received_payment": "已到賬",
    "added_to_showcase": "已加入櫥窗",
    "added_to_cart": "已加入購物車",
    "added_to_selection": "已加入選品庫",
    "added_showcase_short": "已加櫥窗",
    "all_data_loaded": "已加載全部數據",
    "added_selection_short": "已加選品庫",
    "sent_to": "已發送至",
    "cancelled": "已取消",
    "cancelled_remove": "已取消移除",
    "cancelled_top": "已取消置頂",
    "cancelled_default": "已取消默認",
    "sold": "已售",
    "after_sold": "已售後",
    "sold_quantity": "已售數量",
    "already_in": "已在",
    "copied_to_clipboard": "已複製到剪貼板",
    "expired": "已失效",
    "expired_status": "已失效狀態",
    "deposited_to_wallet": "已存入錢包",
    "completed_status": "已完成",
    "sale_started": "已開售",
    "store_opened": "已開店",
    "territory_deleted_success": "已成功刪除領地",
    "signed_up": "已報名",
    "refused": "已拒收",
    "holding": "已持有",
    "collected": "已攬收",
    "paid_status": "已支付",
    "received_goods": "已收到貨",
    "applied_after_sales": "已申請售後",
    "when_logged_in": "已登錄時",
    "signed": "已簽",
    "signed_for": "已簽收",
    "already_hold_digital_goods": "已經持有該數字商品",
    "consecutive_checkin_days": "已經連續簽到",
    "settled": "已結算",
    "obtained": "已獲得",
    "obtained_avatar_frame": "已獲得頭像框組件",
    "decoded": "已解碼",
    "already_set_as_default": "已設為默認",
    "reminder_set": "已設提醒",
    "share_invoked": "已調起分享",
    "max_upload_limit_reached": "已達到最大上傳數量",
    "consecutive_checkin": "已連續簽到",
    "refunded": "已退款",
    "already_selected": "已選",
    "selected_region_display": "已選擇的地區顯示",
    "estimated_commission_from_promotion": "已通過推廣商品獲得的預估傭金",
    "invited": "已邀請",
    "invited_users": "已邀請的用戶",
    "store_closed": "已閉店",
    "read_and_agreed": "已閱讀並同意",
    "reserved": "已預約",
    "claimed": "已領取",
    "defaulted": "已默認",
    "city_suffix": "市",
    "layout_error": "佈局錯誤",
    "bring_revenue": "帶來收入",
    "with_blur_bg": "帶模糊背景",
    "with_white_border": "帶白色邊框",
    "promoting_sales_volume": "帶貨銷量",
    "with_mask_effect": "帶遮罩效果",
    "help_write_station": "幫寫充電站",
    "help_promote_brand": "幫助你喜歡的品牌進行推廣",
    "common_cities": "常用城市",
    "common_tools": "常用工具",
    "common_is": "常見的是",
    "year": "年",
    "yearly_sales": "年銷售額",
    "strict_protection": "並將被嚴格保護",
    "and_earn_commission": "並賺取傭金",
    "and_claim_reward": "並領取獎勵",
    "guangdong_province": "廣東省",
    "square": "廣場",
    "guangzhou_city": "廣州市",
    "serialize_failed": "序列化失敗",
    "stock": "庫存",
    "lib_replace_self": "庫自行替換",
    "yyb_download_failed": "應用寶下載失敗",
    "footer_info": "底部資訊",
    "footer_info_area": "底部資訊區",
    "footer_common": "底部公共部分",
    "footer_area": "底部區域",
    "footer_fixed_profile": "底部固定資料卡",
    "bottom_modal": "底部彈窗",
    "bottom_modal_content": "底部彈窗內容",
    "bottom_button": "底部按鈕",
    "bottom_action_button": "底部操作按鈕",
    "bottom_action_bar": "底部操作欄",
    "bottom_pay_button": "底部支付按鈕",
    "bottom_label_container": "底部標籤容器",
    "bottom_gradient_mask": "底部漸變遮罩",
    "bottom_settlement": "底部結算",
    "bottom_settlement_bar": "底部結算欄",
    "bottom_comment_input": "底部評論輸入欄",
    "bottom_explain_text": "底部說明文字",
    "bottom_buy_button": "底部購買按鈕",
    "shop_available": "店可用",
    "shop_info": "店鋪資訊",
    "shop_info_order_status": "店鋪資訊和訂單狀態",
    "shop_share_card": "店鋪分享卡片",
    "shop_share_modal": "店鋪分享彈窗",
    "shop_list": "店鋪列表",
    "shop_name": "店鋪名稱",
    "shop_return_rate_high": "店鋪回頭率超",
    "shop_preparing": "店鋪籌備中",
    "shop_home": "店鋪首頁",
    "enable": "開啟",
    "start": "開始",
    "start_minute": "開始分鐘",
    "start_init_download": "開始初始化下載",
    "start_loading_fonts": "開始加載字體",
    "start_hour": "開始小時",
    "start_time": "開始時間",
    "account_opened_success": "開戶成功",
    "bank_card_number": "開戶行卡號",
    "bank_address": "開戶行地址",
    "opening_bank": "開戶銀行",
    "open_for_purchase": "開放購買",
    "open_source_address": "開源地址",
    "opening": "開盤",
    "open_brand_new_stronghold": "開闢你的品牌新據點",
    "open_withdrawable": "開通可提現",
    "open_claim_digital_assets": "開通後可領取數字資產",
    "open_digital_wallet": "開通數字錢包",
    "open_date": "開通日期",
    "guide_content": "引導內容",
    "sheet": "張",
    "coupons_available_count": "張優惠券可用",
    "images_count": "張圖片",
    "popup_content": "彈出內容",
    "popup_layer": "彈出層",
    "danmu_track": "彈幕軌道",
    "dialog_box": "彈框",
    "modal": "彈窗",
    "modal_content": "彈窗內容",
    "modal_header": "彈窗頭部",
    "when_disabled": "當不啟用",
    "current": "當前",
    "current_is_not": "當前為非",
    "current_location": "當前位置",
    "current_balance": "當前餘額",
    "balance_insufficient_purchase_hint": "當前餘額不足需充值領鑽後購買",
    "merchant_invited_by_another": "當前商家被另一個商家邀請",
    "screenshot_not_supported": "當前環境不支持截圖功能",
    "bridge_not_supported": "當前環境不支持橋接功能",
    "current_user": "當前登錄用戶",
    "current_user_tag": "當前登錄用戶標籤",
    "when_enabled": "當啟用",
    "pending_payment": "待付款",
    "pending_use": "待使用",
    "pending_ticket": "待出票",
    "pending_seller_delivery": "待賣家交付",
    "pending_seller_accept": "待賣家接單",
    "pending_shipment": "待發貨",
    "pending_merchant_confirm": "待商家確認",
    "pending_merchant_confirm_refund_only": "待商家確認且是僅退款",
    "pending_merchant_confirm_return_refund": "待商家確認且是退款退貨",
    "pending_merchant_refund": "待商家退款",
    "pending_fill_logistics": "待填寫物流資訊",
    "pending_audit": "待審核",
    "pending_open_store": "待開店",
    "pending_pickup": "待提貨",
    "pending_pay": "待支付",
    "pending_receipt": "待收貨",
    "pending_settlement": "待結算",
    "pending_settlement_amount": "待結算金額",
    "pending_evaluation": "待評價",
    "pending_claim": "待領取",
    "very_satisfied": "很滿意",
    "regret": "很遺憾",
    "nice_to_meet_everyone": "很高興認識大家呦",
    "wechat": "微信",
    "wechat_one_click_login": "微信一鍵登錄",
    "wechat_share_thumb": "微信分享縮略圖",
    "wechat_share_thumb_component": "微信分享縮略圖組件",
    "wechat_friend": "微信好友",
    "miniapp_share_cover_generator": "微信小程式分享卡片封面圖生成組件",
    "miniapp_share_thumb": "微信小程式分享縮略圖",
    "miniapp_map_not_supported": "微信小程式環境不支持地圖顯示",
    "wechat_promote": "微信推廣",
    "wechat_pay": "微信支付",
    "wechat_env_hint": "微信環境顯示提示資訊",
    "wechat_login_failed": "微信登錄失敗",
    "wechat_config_init": "微信配置初始化中",
    "required_param_missing": "必填參數缺失",
    "pizza_hotpot": "必勝打邊爐",
    "go_post_memory": "快去發帖紀念一下",
    "go_check_it_out": "快去看看吧",
    "explore_new_world_in_territory": "快去領地探索新世界吧",
    "come_join_territory": "快來加入領地",
    "come_chat_with_me": "快來找我一起聊吧",
    "come_check_it_out": "快來看看吧",
    "express_info_header": "快遞資訊頭部",
    "tracking_number": "快遞單號",
    "express_logistics_info": "快遞和物流資訊",
    "express_order": "快遞訂單",
    "express_delivery": "快遞配送",
    "gender": "性別",
    "gender_age_zodiac_tags": "性別年齡星座等標籤",
    "gender_age_tags": "性別年齡標籤",
    "total_value": "總價值",
    "total_count": "總計",
    "total_amount": "總金額",
    "congrats": "恭喜",
    "congrats_fortune": "恭喜發財",
    "congrats_you": "恭喜您",
    "congrats_become_nth": "恭喜成為第",
    "congrats_signup_success": "恭喜報名活動成功",
    "congrats_obtain": "恭喜獲得",
    "congrats_unlock_achievement": "恭喜解鎖首周全勤成就",
    "congrats_first_checkin": "恭喜首簽",
    "you_can_repay": "您可重新支付",
    "you_joined_showcase": "您已加入櫥窗",
    "you_joined_selection": "您已加入選品庫",
    "you_applied_refund": "您已成功發起退款申請",
    "you_revoked_after_sales": "您已撤銷售後",
    "you_applied_refund_simple": "您已申請退款",
    "you_passed_territory_auth": "您已通過領地認證",
    "you_currently_have": "您當前有",
    "you_have": "您有",
    "your": "您的",
    "your_referrer_is": "您的上級領航員是",
    "your_info_usage": "您的資訊僅為上述用途提供",
    "your_info_protected": "您的資訊將嚴格加密保護",
    "your_account_info_error": "您的開戶資訊有誤",
    "your_led_balance_insufficient": "您的領點餘額不足",
    "your_lzd_balance_insufficient": "您的領鑽餘額不足",
    "you_cannot_withdraw_yet": "您還無法提現",
    "you_not_bind_phone": "您還未綁定手機號",
    "you_selected_too_many_tags": "您選的標籤太多啦",
    "surprise_double": "驚喜加倍",
    "surprise_red_packet": "驚喜紅包",
    "thanks_support_opensource": "感謝支持開源",
    "become_distributor": "成為分銷員",
    "sales_volume_rank": "成交量排名",
    "transaction_amount": "成交金額",
    "success_join_territory": "成功加入一個領地",
    "member_alt": "成員",
    "member_list": "成員列表",
    "member_center": "會員中心",
    "member_center_default_card": "會員卡",
    "member_rights": "會員權益",
    "member_rights_count_suffix": "項權益",
    "member_code": "會員碼",
    "member_verification_code": "會員核銷碼",
    "member_mine": "我的",
    "member_increase": "成員增加",
    "member_action": "成員操作",
    "chengdu_city": "成都市",
    "growth": "成長",
    "growth_value": "成長值",
    "me": "我",
    "i_want_auth": "我也要認證",
    "we_will_auto_register": "我們將自動為您註冊",
    "we_need_realname_auth": "我們需要進行實名認證",
    "i_joined": "我加入了",
    "i_joined_adj": "我加入的",
    "i_promoting_in_territory": "我在領地正在幫品牌進行推廣",
    "i_hold_digital_assets": "我持有的數字權益資產",
    "i_am": "我是",
    "i_am_here": "我來嘍",
    "my": "我的",
    "my_card_pack": "我的卡包",
    "my_qrcode": "我的二維碼",
    "my_coupons": "我的優惠券",
    "my_nft": "我的NFT",
    "my_member_points": "我的積分",
    "monthly_exclusive_coupon": "每月專屬優惠券",
    "all_discount_offer": "全場8折優惠",
    "points_reward": "積分獎勵",
    "exclusive_event": "專屬活動",
    "birthday_exclusive_gift": "生日專屬禮包",
    "open_membership_now": "立即開通",
    "my_follows": "我的關注",
    "my_moments": "我的動態",
    "my_addresses": "我的地址",
    "my_digital_assets": "我的數字資產",
    "my_tags": "我的標籤",
    "my_activities": "我的活動",
    "my_fans": "我的粉絲",
    "my_orders": "我的訂單",
    "membership_card_order": "會員卡訂單",
    "membership_card_usage_record": "會員卡使用記錄",
    "membership_validity": "會員有效期",
    "member_card_points": "會員卡積分",
    "membership_number": "會員編號",
    "my_selection_library": "我的選品庫",
    "my_wallet": "我的錢包",
    "nft_digital_asset_order": "NFT數字資產訂單",
    "invitation_record": "邀請記錄",
    "view_points_detail": "查看積分明細",
    "view_coupon_pack": "查看券包",
    "please_show_qr_to_staff": "請將二維碼出示給店員掃描",
    "qr_refresh_after_scan": "每次掃碼後二維碼將立即更新",
    "qr_auto_refresh": "二維碼將在{seconds}秒後自動刷新",
    "other_benefits": "其他權益",
    "purchase_notice": "購買須知",
    "actual_payment": "實付金額",
    "tap_for_details": "點擊查看詳情",
    "feature_coming_soon": "敬請期待",
    "my_lzd": "我的領鑽",
    "i_know": "我知道了",
    "i_want_auth_merchant": "我要認證成為商家",
    "i_invited": "我邀請的",
    "i_earned_a_lot": "我都賺麻",
    "i_earned_a_lot_full": "我都賺麻了",
    "or_buy_via_link": "或分享的鏈接中購買",
    "or": "或者",
    "screenshot_failed": "截圖失敗",
    "screenshot_gen_failed": "截圖生成失敗",
    "screenshot_error": "截圖過程中發生未知錯誤",
    "click_link_get_coupon": "戳鏈接領優惠",
    "location_place": "所在地",
    "location_region": "所在地區",
    "belong_merchant": "所屬商戶",
    "all_fonts_loaded_alt": "所有字體加載完成",
    "all_batch_events_passed": "所有批量事件通過",
    "manually_extracted": "手動提取的",
    "manual_parse": "手動解析",
    "manual_decode": "手動解碼",
    "manual_trigger_download": "手動觸發下載",
    "mobile_number": "手機號",
    "phone_number": "手機號碼",
    "only_then_can_send_red_packet": "才可以在地圖上發送紅包哦",
    "pack_pickup": "打包自提",
    "open": "打開",
    "build_digital_ecology": "打造專屬你的數字生態",
    "tax_deduction_rules": "扣稅規則",
    "scan": "掃一掃",
    "scan_qrcode": "掃描二維碼",
    "scan_button": "掃描按鈕",
    "scan_find_me": "掃碼進到小程式找到我",
    "batch_send_failed": "批次發送失敗",
    "batch_send_exception": "批次發送異常",
    "batch_send_success": "批次發送成功",
    "batch_request_timeout": "批次請求超時",
    "batch": "批量",
    "batch_event_passed": "批量事件通過",
    "batch_add_showcase": "批量加櫥窗",
    "batch_send_failed_alt": "批量發送失敗",
    "batch_send_exception_alt": "批量發送異常",
    "cabinet_or_station": "投櫃或站簽收",
    "cabinet_or_station_alt": "投櫃或驛站",
    "discount": "折",
    "line_chart": "折線圖",
    "grab_red_packet_agree": "搶紅包代表同意",
    "rush_buy": "搶購",
    "passport": "護照",
    "signup_info": "報名資訊",
    "signup_info_modal": "報名資訊彈窗",
    "signup_participate": "報名參與",
    "signup_failed": "報名失敗",
    "signup_success": "報名成功",
    "signup_detail": "報名詳情",
    "block": "拉黑",
    "block_success": "拉黑成功",
    "reject_reason": "拒絕原因",
    "reject_time": "拒絕時間",
    "access_denied": "拒絕訪問",
    "own": "擁有",
    "try_luck": "拼手氣",
    "upload_holder_id": "持卡人證件上傳",
    "hold": "持有",
    "holder": "持有人",
    "holder_count": "持有人數",
    "after_holding": "持有後",
    "hold_digital_product": "持有數字商品",
    "after_holding_digital_product": "持有數字商品後",
    "hold_digital_asset": "持有數字資產",
    "hold_digital_identity": "持有數字身份",
    "hold_data": "持有數據",
    "held_digital_assets": "持有的數字資產",
    "holder_alt": "持有者",
    "holder_revenue": "持有者收益",
    "hold_territory_identity": "持有領地數字身份",
    "within_designated_period": "指定週期內",
    "by_commission": "按傭金",
    "button": "按鈕",
    "button_element_not_found": "按鈕元素未找到",
    "button_group_render": "按鈕分組渲染",
    "by_sales": "按銷量",
    "try_another_network": "換個網絡試試",
    "explore_journey_start": "探索之旅正式開啟",
    "promotion_alt": "推廣",
    "promotion_tool": "推廣工具",
    "promotion_record": "推廣記錄",
    "promote_earn_cash": "推廣賺現金",
    "promote_navigator": "推廣領航員",
    "recommend": "推薦",
    "recommend_others_buy": "推薦他人購買",
    "recommend_use": "推薦使用",
    "recommend_content_list": "推薦內容列表",
    "recommend_alliance": "推薦聯營",
    "recommend_page": "推薦頁",
    "recommend_territory": "推薦領地",
    "description_text": "描述文本",
    "description_input_area": "描述輸入區域",
    "submit": "提交",
    "submitting": "提交中",
    "audit_after_submit": "提交後會進入到審核階段",
    "submit_success": "提交成功",
    "submit_button": "提交按鈕",
    "upgrade_personal_level": "提升你的個人等級",
    "extract_image_color_failed": "提取圖片顏色失敗",
    "withdraw": "提現",
    "withdraw_commission": "提現分銷傭金",
    "withdraw_success": "提現成功",
    "withdraw_apply": "提現申請",
    "hint": "提示",
    "hint_text": "提示文字",
    "hint_content": "提示文案",
    "hint_page": "提示頁",
    "plugin_market_url": "插件市場地址",
    "search": "搜索",
    "search_placeholder": "搜索占位文本",
    "search_history": "搜索歷史記錄",
    "search_icon": "搜索圖標",
    "search_place": "搜索地點",
    "search_shop": "搜索店鋪",
    "search_box": "搜索框",
    "search_box_mode": "搜索框模式",
    "search_box_click": "搜索框點擊事件",
    "search_input": "搜索輸入框",
    "search_territory": "搜索領地",
    "select_territory": "選擇領地",
    "please_select_territory": "請選擇領地",
    "no_territory_found": "未找到領地",
    "camera_no_permission": "攝像頭無權限或無法獲取攝像頭數據",
    "revoke_after_sales": "撤銷售後",
    "revoke_after_sales_failed": "撤銷售後失敗",
    "revoke_after_sales_success": "撤銷售後成功",
    "revoke_time": "撤銷時間",
    "operating": "操作中",
    "operation_loading": "操作加載狀態",
    "operation_failed": "操作失敗",
    "operation_button": "操作按鈕",
    "operation_button_area": "操作按鈕區域",
    "paying": "支付中",
    "payment_countdown": "支付倒計時",
    "payment_dev_in_progress": "支付功能開發中",
    "after_payment": "支付後",
    "cancel_after_payment": "支付後取消",
    "payment_failed": "支付失敗",
    "alipay": "支付寶",
    "alipay_miniapp": "支付寶小程式",
    "payment_modal": "支付彈窗",
    "payment_success": "支付成功",
    "payment_method": "支付方式",
    "payment_method_select": "支付方式選擇",
    "payment_serial_no": "支付流水號",
    "payment_result": "支付結果",
    "payment_amount": "支付金額",
    "expenditure": "支出",
    "income_expenditure_detail": "支出和收入明細",
    "support": "支持",
    "support_slot": "支持插槽",
    "recipient": "收件人",
    "recipient_info": "收件人資訊",
    "income": "收入",
    "revenue": "收益",
    "revenue_rank": "收益排行榜",
    "revenue_curve": "收益曲線",
    "revenue_tag": "收益標籤",
    "revenue_rate": "收益率",
    "close_market": "收盤",
    "collection_total_value": "收藏總價值",
    "receiver": "收貨人",
    "receive_place": "收貨地",
    "shipping_address": "收貨地址",
    "shipping_address_info": "收貨地址資訊",
    "collapse": "收起",
    "put_store_poster": "放到門店海報",
    "scatter_chart": "散點圖",
    "count": "數",
    "digital_product_purchase_notice": "數字產品購買須知",
    "digital_member_card": "數字會員卡",
    "digital_member_promote": "數字會員推廣",
    "digital_product": "數字商品",
    "digital_exhibition": "數字展館",
    "digital_asset_wallet": "數字資產錢包",
    "how_to_buy_digital_assets": "數字權益資產怎麼買",
    "what_use_digital_assets": "數字權益資產有什麼用",
    "digital_assets_order": "數字權益資產訂單",
    "digital_equity_token": "數字權益通證",
    "digital_collection": "數字藏品",
    "digital_asset_equity": "數字資產對應權益",
    "digital_asset_holding": "數字資產持有與沉澱",
    "digital_asset_msg": "數字資產消息",
    "digital_asset_order": "數字資產訂單",
    "data": "數據",
    "data_empty": "數據為空",
    "data_load_failed": "數據加載失敗",
    "data_format_error": "數據格式錯誤",
    "data_type_error": "數據類型錯誤",
    "data_error_exception": "數據錯誤或程式異常",
    "data_must_be": "數據需為",
    "digital_asset_total_value": "數資總價值",
    "digital_asset_count": "數資數量",
    "file": "檔",
    "file_size_exceed": "檔大小不能超過",
    "file_too_small": "檔太小",
    "file_failed": "檔失敗",
    "file_format": "檔格式",
    "new_world": "新世界",
    "newcomer_report": "新人報道",
    "new_product": "新品",
    "new_product_tag": "新品標籤",
    "add_shipping_address": "新增收貨地址",
    "create_address": "新建地址",
    "novice_navigator": "新手航客",
    "new_retail_detail": "新零售詳情",
    "method": "方式",
    "invalid_number": "無效數字",
    "invalid_adj": "無效的",
    "invalid_hex_color": "無效的十六進制顏色值",
    "invalid_sale_time": "無效的開售時間",
    "no_data": "無數據",
    "upload_image_failed": "無法上傳圖片",
    "create_failed": "無法創建",
    "copy_failed_alt": "無法複製",
    "copy_link_failed": "無法複製鏈接",
    "login_failed": "無法登錄",
    "obtain_failed": "無法獲取",
    "obtain_user_info_failed": "無法獲取當前用戶資訊",
    "claim_failed": "無法領取",
    "no_comment_placeholder": "無評論占位",
    "no_threshold": "無門檻",
    "no_need_join_again": "無需重複加入",
    "day_char": "日",
    "calendar": "日曆",
    "date": "日期",
    "date_select": "日期選擇",
    "date_picker": "日期選擇器",
    "old_version": "舊版",
    "times_paradise_walk": "時代天街",
    "display_when": "時顯示",
    "timestamp_setting": "時間戳設置",
    "timeline_content": "時間線內容",
    "timeline_icon": "時間線圖標",
    "timeline_area": "時間軸區域",
    "timeline_line": "時間軸折線",
    "time_select": "時間選擇",
    "time_picker_modal": "時間選擇彈窗",
    "tomorrow": "明天",
    "detail_list": "明細列表",
    "star_domain_commander": "星域指揮官",
    "star_domain_overlord": "星域霸主",
    "starbucks": "星巴克",
    "zodiac_tag": "星座標籤",
    "save_modified_info_confirm": "是否保存本次修改的資訊",
    "delete_address_confirm": "是否刪除該地址",
    "enable_follow_reward_confirm": "是否開啟關注後領取",
    "delete_account_confirm": "是否註銷賬號",
    "delete_territory_confirm": "是否確認刪除領地",
    "leave_territory_confirm": "是否確認離開領地",
    "auto_focus_confirm": "是否自動獲取焦點",
    "logout_confirm": "是否退出登錄",
    "nickname": "昵稱",
    "after_nickname_birthday": "昵稱與生日後",
    "nickname_no_politics": "昵稱中請勿含有涉及政治",
    "after_nickname": "昵稱後",
    "nickname_and_badge": "昵稱和勛章",
    "nickname_and_badge_alt": "昵稱和徽章",
    "show_send_button": "顯示發送按鈕",
    "show_province": "顯示省份",
    "show_comment_count": "顯示評論總數",
    "show_default_action_button": "顯示默認操作按鈕",
    "normal": "普通",
    "normal_member": "普通會員",
    "normal_product_card": "普通商品卡片",
    "normal_member_alt": "普通成員",
    "normal_button_bind_success": "普通按鈕綁定成功",
    "smart_contract_desc": "智能合約基於貢獻自動分賬激勵協作高效增長",
    "temp_no_revoke": "暫不撤銷",
    "temp_not_supported": "暫不支持",
    "temp_no_video_upload": "暫不支持上傳視頻",
    "temp_no_select": "暫不選擇",
    "temp_none": "暫無",
    "temp_no_people_info": "暫無人數資訊",
    "temp_no_coupon": "暫無優惠券可用",
    "temp_no_member_card_info": "暫無會員卡資訊",
    "temp_no_content": "暫無內容",
    "temp_no_product": "暫無商品",
    "temp_no_address": "暫無地址",
    "temp_no_signup_info": "暫無報名資訊",
    "temp_no_revenue": "暫無收益",
    "temp_no_shipping_address": "暫無收貨地址",
    "temp_no_data": "暫無數據",
    "temp_no_time_info": "暫無時間資訊",
    "temp_no_order": "暫無訂單",
    "temp_no_invite_data": "暫無邀請數據",
    "temp_no_invite_record": "暫無邀請記錄",
    "temp_no_bank_data": "暫無銀行數據",
    "temp_no_store": "暫無門店",
    "temp_no_territory_intro": "暫無領地介紹",
    "temp_no_more": "暫時沒有更多了",
    "temp_not_used": "暫未使用",
    "temp_not_joined_store": "暫未入駐門店",
    "more": "更多",
    "more_vouchers": "更多代金券",
    "more_placeholder": "更多占位符",
    "more_rewards": "更多獎勵",
    "more_buttons": "更多按鈕等",
    "more_powerful": "更強大",
    "change_avatar": "更換頭像",
    "change_bank_card": "更換銀行卡",
    "lowest": "最低",
    "most": "最多",
    "max_upload": "最多上傳",
    "max_send": "最多發送",
    "max_display": "最多展示",
    "final_earn_amount_hint": "最終可賺金額以用戶實際結算金額為準",
    "final_interpretation_rights": "最終解釋權歸平臺所有",
    "recent": "最近",
    "recent_search": "最近搜索",
    "highest": "最高",
    "max_earn": "最高可賺",
    "month": "月",
    "monthly_sales": "月售",
    "monthly_sales_volume": "月銷",
    "help_merchant_handle_after_sales": "有助於商家更好的處理售後問題",
    "show_when_has_address": "有地址時顯示",
    "validity_period": "有效期",
    "validity_type": "有效期類型",
    "validity_type_selector": "有效期類型選擇器",
    "valid_until": "有效期至",
    "validity_selection": "有效期選擇",
    "service": "服務",
    "service_unavailable": "服務不可用",
    "server_error": "服務器錯誤",
    "service_not_implemented": "服務未實現",
    "service_tag_and_sales": "服務標籤和銷量",
    "service_type": "服務類型",
    "service_order": "服務訂單",
    "service_fee": "服務費用",
    "chaoyang_district": "朝陽區",
    "uninitialized": "未初始化",
    "dont_give_code_before_arrival": "未到店前請勿將券碼提供給商家",
    "location_permission_not_enabled": "未開啟定位權限",
    "not_on_sale_but_reserved": "未開售且已預約",
    "not_on_sale_and_not_reserved": "未開售且未預約",
    "minors_cannot_recharge": "未成年人不允許充值",
    "not_found": "未找到",
    "related_bank_not_found": "未找到相關銀行",
    "certificate_element_not_found": "未找到證書元素",
    "unauthorized": "未授權",
    "not_received_goods": "未收到貨",
    "phone_not_registered_territory": "未註冊領地的手機號",
    "not_logged_in": "未登錄",
    "unknown": "未知",
    "unknown_merchant": "未知商家",
    "unknown_user": "未知用戶",
    "unknown_error": "未知錯誤",
    "not_obtained": "未獲取到",
    "parent_dim_not_obtained": "未獲取到父元素寬高尺寸",
    "image_data_not_obtained": "未獲得圖片數據",
    "nickname_not_set": "未設置昵稱",
    "unclaimed_red_packet": "未領取的紅包",
    "commission_this_order": "本單傭金",
    "hot_sale_this_week": "本周熱賣",
    "hot_this_week": "本周熱門",
    "withdraw_amount_this_time": "本次提現金額",
    "rights": "權益",
    "rights_updated_regularly": "權益定期更新",
    "rights_desc": "權益說明",
    "permission_denied": "權限不足",
    "permission_hint": "權限提示",
    "permission_not_enabled": "權限未開啟",
    "strip": "條",
    "connections_count": "條人脈",
    "replies_count": "條回復",
    "local_life_videos_count": "條本地生活視頻",
    "bar_chart": "條狀圖",
    "comments_count": "條評論",
    "introduce_your_territory": "來介紹一下你的領地吧",
    "mainland_travel_permit_hkmc": "來往內地通行證",
    "mainland_travel_permit_taiwan": "來往大陸通行證",
    "come_see_my_homepage": "來看看我的主頁",
    "from_source": "來自",
    "hangzhou_city": "杭州市",
    "view": "查看",
    "view_personal_homepage": "查看個人主頁",
    "view_all": "查看全部",
    "view_coupon_code": "查看券碼",
    "view_full_ranking": "查看完整榜單",
    "view_promotion_record": "查看推廣記錄",
    "view_more": "查看更多",
    "view_more_exciting": "查看更多精彩",
    "view_logistics": "查看物流",
    "view_cash_balance": "查看現金餘額",
    "view_order": "查看訂單",
    "view_order_status": "查看訂單狀態",
    "view_detail": "查看詳情",
    "view_store": "查看門店",
    "view_territory": "查看領地",
    "column_chart": "柱狀圖",
    "tag": "標籤",
    "tag_and_desc": "標籤和描述",
    "tag_row": "標籤行",
    "mark_location": "標記地點",
    "title": "標題",
    "title_and_badge_area": "標題和徽章區域",
    "title_and_desc": "標題和說明",
    "title_slot": "標題插槽",
    "title_bar": "標題欄",
    "title_mode": "標題模式",
    "validating": "校驗中",
    "validation_failed": "校驗失敗",
    "validation_passed": "校驗通過",
    "according_to": "根據",
    "render_template_by_share_type": "根據分享類型渲染對應範本",
    "compliance_requirements": "根據合規要求",
    "format": "格式",
    "offline_places_like_table_card": "桌卡等線下位置",
    "device_brand_detected": "檢測到設備品牌",
    "mode": "模式",
    "mode_not_support_refresh": "模式不支持刷新",
    "after_mode": "模式後",
    "template_injected_at_runtime": "範本內容通過腳本在運行時注入",
    "template_gen_share_cover": "範本方式生成分享封面圖",
    "blur_background": "模糊背景",
    "horizontal_scroll_info": "橫向滾動資訊",
    "horizontal_scroll_image_list": "橫向滾動圖片列表",
    "showcase": "櫥窗",
    "showcase_share_card": "櫥窗分享卡片",
    "showcase_card_template": "櫥窗卡片範本",
    "showcase_status": "櫥窗狀態",
    "showcase_bg_image": "櫥窗背景圖片",
    "showcase_page": "櫥窗頁面",
    "times": "次",
    "times_recharge": "次充電",
    "refresh_purchase_count_next_day": "次日淩晨刷新購買次數",
    "welcome_to": "歡迎來到",
    "welcome_to_territory": "歡迎來到領地",
    "is_being": "正在",
    "is_downloading": "正在下載",
    "is_loading_more": "正在加載更多",
    "is_loading_bank_list": "正在加載銀行列表",
    "is_processing": "正在處理",
    "is_paying": "正在支付",
    "is_chatting": "正在熱聊",
    "generating_image": "正在生成圖片",
    "generating_poster": "正在生成海報",
    "trigger_business_normal": "正常觸發業務",
    "moment_content_by": "此動態文字內容由",
    "phone_used_for_merchant_login": "此手機號將用於登錄商家端",
    "step_list": "步驟列表",
    "persistence_pays_off": "毅力初成",
    "each": "每個",
    "limit_per_person": "每人限購",
    "max_earn_per_order": "每單最高可賺",
    "daily_buy_limit_restricted": "每日購買領點次數均有限制",
    "commission_ratio_per_time": "每次獲得分銷傭金的",
    "drugs_text_info": "毒品的文字資訊",
    "ratio": "比例",
    "bubble_content": "氣泡內容",
    "bubble_chart": "氣泡圖",
    "permanent": "永久",
    "accumulate_personal_digital_assets": "沉澱個人數字資產",
    "accumulate_high_quality_relations": "沉澱高質量關係",
    "no_add_to_cart_feature": "沒有加入購物車功能",
    "no_more_data": "沒有更多數據",
    "no_more_data_text": "沒有更多數據了",
    "no_more_data_hint": "沒有更多數據提示",
    "no_valid_business_data": "沒有有效的業務數據",
    "attention": "注意",
    "delete_account": "註銷賬號",
    "activity": "活動",
    "activity_people_count": "活動人數",
    "activity_intro": "活動介紹",
    "activity_list": "活動列表",
    "activity_profit_ratio": "活動利潤的",
    "activity_location": "活動地點",
    "activity_signup": "活動報名",
    "activity_calendar": "活動日曆",
    "activity_time": "活動時間",
    "activity_detail": "活動詳情",
    "delivering": "派送中",
    "traffic_content_asset_chain": "流量內容用戶資產上鏈確權沉澱長期價值增長",
    "test": "測試",
    "test_address": "測試地址",
    "zhejiang_province": "浙江省",
    "poster_card_container": "海報卡片容器",
    "poster_modal": "海報彈窗",
    "poster_promote": "海報推廣",
    "poster_generating": "海報生成中",
    "haidian_district": "海澱區",
    "message": "消息",
    "message_list": "消息列表",
    "message_red_dot": "消息紅點",
    "shenzhen_city": "深圳市",
    "shenzhen_territory_tech": "深圳領地數資科技有限公司",
    "mixed_chart": "混合圖",
    "add_follow_failed": "添加關注失敗",
    "add_image_button": "添加圖片按鈕",
    "add_address": "添加地址",
    "add_failed": "添加失敗",
    "add_success": "添加成功",
    "bar": "清吧",
    "clear_cart": "清空購物車",
    "clear_search_history": "清除搜索記錄",
    "gradient_top": "漸變色頂部",
    "gradient_mask": "漸變遮罩",
    "channel": "管道",
    "channel_member": "管道成員",
    "warm_tips": "溫馨提示",
    "hkmc_resident_permit": "港澳居民證",
    "render_chart": "渲染圖表",
    "render_sub_reply_list": "渲染子回復列表",
    "hunan_province": "湖南省",
    "full": "滿",
    "funnel_chart": "漏斗圖",
    "activate": "啟動",
    "activate_distributor": "啟動分銷員",
    "activate_distributor_title": "啟動分銷員標題",
    "waterfall": "瀑布流",
    "waterfall_content": "瀑布流內容",
    "inspiration_burst": "靈感爆棚",
    "lingdie_limited_avatar_frame": "靈蝶物語限定頭像框",
    "lingdie_limited_frame_particle": "靈蝶物語限定頭像框啦",
    "point": "點",
    "click": "點擊",
    "click_upload": "點擊上傳",
    "click_button_below": "點擊下方按鈕",
    "click_button_below_view": "點擊下方按鈕查看",
    "clicked_center_bump": "點擊了中間的鼓包",
    "click_to_join_store": "點擊入駐",
    "click_go_group_buy": "點擊去拼團吧",
    "click_go_look": "點擊去看看吧",
    "click_button": "點擊按鈕",
    "click_view": "點擊查看",
    "click_view_moment_detail": "點擊查看動態詳情",
    "click_view_activity_detail": "點擊查看活動詳情",
    "click_claim_now": "點擊立即領取",
    "click_trigger_business": "點擊觸發業務邏輯",
    "click_retry": "點擊重試",
    "like": "點贊",
    "like_content": "點贊內容",
    "like_success": "點贊成功",
    "like_button": "點贊按鈕",
    "like_count": "點贊數",
    "like_data": "點贊數據",
    "like_message": "點贊消息",
    "like_comment": "點贊評論",
    "calendar_remind_time": "點進行日曆提醒",
    "hot_sales_ranking": "熱賣排行榜",
    "hot_sales_rank": "熱賣榜",
    "hot_sales": "熱銷",
    "hot_products": "熱門商品",
    "hot_merchants": "熱門商家",
    "hot_rank": "熱門榜",
    "best_selling": "爆款暢銷",
    "parent_menu": "父級菜單",
    "version": "版本",
    "version_not_supported": "版本不受支持",
    "version_no": "版本號",
    "version_suffix": "版本後",
    "logistics": "物流",
    "logistics_info": "物流資訊",
    "logistics_company": "物流公司",
    "logistics_company_modal": "物流公司選擇彈窗",
    "logistics_timeline": "物流時間線",
    "logistics_fast": "物流超快",
    "featured_tag": "特色標籤",
    "status_tab": "狀態標籤頁",
    "status_bar_placeholder": "狀態欄占位區域",
    "status_code": "狀態碼",
    "exclusive_debut": "獨家首發",
    "cat_dog_general": "貓咪狗狗通用",
    "return_of_king": "王者歸來",
    "gameplay_rules": "玩法說明",
    "rose_chart": "玫瑰圖",
    "environment": "環境",
    "cash_balance": "現金餘額",
    "reason_alt": "理由",
    "luckin_coffee": "瑞幸咖啡小藍杯",
    "bottle_beer": "瓶啤酒",
    "generate": "生成",
    "generate_qrcode_failed": "生成二維碼失敗",
    "generate_share_image": "生成分享圖片",
    "generate_share_cover": "生成分享封面圖",
    "generate_image_timeout": "生成圖片超時",
    "generate_suncode_failed": "生成太陽碼失敗",
    "generate_miniapp_link_failed": "生成小程式鏈接失敗",
    "generate_promote_fingerprint_failed": "生成推廣指紋碼失敗",
    "generate_poster": "生成海報",
    "generating_poster_status": "生成海報中",
    "generating_certificate": "生成證書中",
    "generate_link_failed": "生成鏈接失敗",
    "birthday": "生日",
    "use_prep": "用",
    "used_for_screenshot": "用於截圖",
    "used_for_pregen_share_cover": "用於預生成分享封面圖",
    "user": "用戶",
    "user_homepage": "用戶主頁",
    "user_homepage_card_template": "用戶主頁卡片範本",
    "user_info": "用戶資訊",
    "user_info_content": "用戶資訊內容",
    "user_info_loading": "用戶資訊加載中",
    "user_info_section": "用戶資訊區",
    "user_info_area": "用戶資訊區域",
    "user_info_card": "用戶資訊卡片",
    "user_info_row": "用戶資訊行",
    "user_followed_you": "用戶關注了你",
    "user_share_card": "用戶分享卡片",
    "user_list": "用戶列表",
    "user_moment_card": "用戶動態卡片",
    "user_medal": "用戶勛章",
    "user_agreement": "用戶協議",
    "username_and_avatar": "用戶名和頭像",
    "user_avatar": "用戶頭像",
    "user_avatar_as_bg": "用戶頭像作為背景",
    "user_avatar_list": "用戶頭像列表",
    "after_user_scan": "用戶掃碼後",
    "user_invite_merchant": "用戶拉商家",
    "user_nickname": "用戶昵稱",
    "user_not_login": "用戶未登錄",
    "user_level": "用戶等級",
    "user_red_packet_protocol": "用戶紅包獎勵協議",
    "user_contribution": "用戶貢獻",
    "user_logout": "用戶退出",
    "user_privacy_policy": "用戶隱私協議",
    "apply_create_territory": "申請創建領地",
    "apply_collaboration": "申請合作",
    "apply_after_sales": "申請售後",
    "after_apply_audit_passed": "申請審核通過後",
    "apply_time": "申請時間",
    "apply_refund": "申請退款",
    "phone": "電話",
    "phone_number_error": "電話號碼錯誤",
    "male": "男",
    "canvas": "畫布",
    "speak_freely": "暢所欲言",
    "speak_freely_system_upgrade": "暢所欲言系統已全面升級",
    "login": "登錄",
    "logging_in": "登錄中",
    "after_login": "登錄後",
    "login_failed_alt": "登錄失敗",
    "login_expired": "登錄已過期",
    "login_success": "登錄成功",
    "login_phone": "登錄手機號",
    "auto_register_at_login": "登錄時將自己註冊",
    "login_form_area": "登錄表單區域",
    "white_background": "白色背景",
    "white_bg_card": "白色背景卡片",
    "white_transparent_mask": "白色透明遮罩",
    "white_clam_butterfly": "白蜆蝶",
    "silver_navigator": "白銀領航員",
    "percentage": "百分比",
    "of_de": "的",
    "of_follow": "的關注",
    "of_group_buy": "的團購",
    "of_processing": "的處理",
    "of_recommend": "的推薦",
    "of_showcase": "的櫥窗",
    "of_fans": "的粉絲",
    "of_drawing_context": "的繪圖上下文並傳入",
    "blind_box_product_name": "盲盒商品名稱",
    "blind_box_product_image": "盲盒商品圖",
    "direct_download": "直接下載",
    "live_streaming": "直播中",
    "related_recommend": "相關推薦",
    "equivalent_to": "相當於",
    "province_list": "省份列表",
    "province_level": "省份級別",
    "real_name": "真實姓名",
    "known_it": "知道了",
    "confirm": "確定",
    "confirm_delete": "確定刪除",
    "confirm_equip": "確定裝扮",
    "confirm_delete_moment": "確定要刪除動態嗎",
    "confirm_clear_cart": "確定要刪除購物車中所有商品",
    "confirm_unfollow": "確定要取消關注嗎",
    "confirm_cancel_order": "確定要取消訂單嗎",
    "confirm_revoke_after_sales": "確定要撤銷本次申請售後嗎",
    "confirm_buy": "確定要購買",
    "confirm_alt": "確認",
    "confirm_cancel_payment": "確認取消支付嗎",
    "confirm_revoke": "確認撤銷",
    "confirm_pay": "確認支付",
    "confirm_pay_button": "確認支付按鈕",
    "confirm_receipt": "確認收貨",
    "after_confirm_receipt": "確認收貨後",
    "confirm_receipt_success": "確認收貨成功",
    "confirm_clear_search_history": "確認清除所有搜索記錄嗎",
    "confirm_order": "確認訂單",
    "gift": "禮物",
    "blessing": "祝福語",
    "leave_territory": "離開領地",
    "private_domain_fission": "私域裂變",
    "qiuyun": "秋雲",
    "qiuyun_charts": "秋雲高性能跨全端圖表組件",
    "share_type_kinds": "種分享類型",
    "seconds": "秒",
    "expire_in_seconds": "秒到期",
    "seconds_video": "秒的視頻",
    "sold_out_in_seconds": "秒被搶光",
    "points": "積分",
    "points_module": "積分模塊",
    "operate_remove_in_detail": "移除功能請在詳情頁操作",
    "remove_success": "移除成功",
    "remove_channel": "移除頻道",
    "rare": "稀有",
    "hollow_star": "空心星",
    "empty_data_state": "空數據狀態",
    "empty_state": "空狀態",
    "recharge_now": "立即充值",
    "open_now": "立即開啟",
    "own_now": "立即擁有",
    "view_now": "立即查看",
    "activate_digital_product_now": "立即啟動您的數字商品",
    "checkin_now": "立即簽到",
    "verify_now": "立即認證",
    "buy_now": "立即購買",
    "book_now": "立即預約",
    "claim_now": "立即領取",
    "placeholder_pos": "站位",
    "symbol": "符號",
    "rank_prefix": "第",
    "step_one": "第一步",
    "received_next_day": "第二天就收到了",
    "step_two": "第二步",
    "etc": "等",
    "level_list": "等級列表",
    "level_upgrade": "等級升級",
    "higher_level": "等級越高",
    "spec_options_available": "等規格可選",
    "filter_button": "篩選按鈕",
    "filter_tag": "篩選標籤",
    "filter_bar": "篩選欄",
    "filter_mask": "篩選遮罩層",
    "checkin_days": "簽到天數",
    "checkin_success": "簽到成功",
    "checkin_remind": "簽到提醒",
    "checkin_remind_on": "簽到提醒已開啟",
    "checkin_calendar": "簽到日曆",
    "checkin_grid": "簽到格子",
    "checkin_rank": "簽到第",
    "signature_alt": "簽名",
    "signature_no_politics": "簽名中請勿含有涉及政治",
    "signature_param_incomplete": "簽名參數不完整",
    "sign_distributor_contract": "簽署分銷合同",
    "management": "管理",
    "admin": "管理員",
    "meter": "米",
    "type": "類型",
    "type_incorrect": "類型不正確",
    "type_will_be_at": "類型會在",
    "fans": "粉絲",
    "fans_count_etc": "粉絲和關注等數量",
    "yue_province": "粵",
    "series": "系列",
    "series_count": "系列個數",
    "series_product": "系列商品",
    "system": "系統",
    "system_message": "系統消息",
    "purple_background": "紫色背景",
    "accumulate_led": "累計得領點",
    "accumulate_lzd": "累計得領鑽",
    "accumulate_revenue": "累計收益",
    "accumulate_revenue_amount": "累計收益金額",
    "accumulate_obtain": "累計獲得",
    "accumulate_earn_commission": "累計賺傭",
    "accumulate_invite": "累計邀請",
    "accumulate_invite_count": "累計邀請人數",
    "red_packet": "紅包",
    "red_packet_count": "紅包個數",
    "red_packet_count_limit": "紅包個數不可以超過",
    "red_packet_share_card": "紅包分享卡片",
    "level_distributor": "級分銷員",
    "level_territory": "級領地",
    "line_chart_alt": "線圖",
    "component_gen_qrcode": "組件自己負責二維碼生成",
    "combined_use": "組合使用",
    "bind_success": "綁定成功",
    "bind_phone": "綁定手機號",
    "bind_time": "綁定時間",
    "bind_invite_code": "綁定邀請碼",
    "bind_bank_card": "綁定銀行卡",
    "end": "結束",
    "end_minute": "結束分鐘",
    "end_hour": "結束小時",
    "end_time": "結束時間",
    "settling": "結算中",
    "settlement_record": "結算記錄",
    "draw_avatar_failed": "繪製頭像失敗",
    "bring_to_holder": "給持有者帶來",
    "stats_data": "統計數據",
    "continue_open": "繼續開啟",
    "continue_pay": "繼續支付",
    "green_dot": "綠點",
    "removed_at_compile": "編譯階段移除",
    "edit_address": "編輯地址",
    "edit_shipping_address": "編輯收貨地址",
    "missing": "缺",
    "network_upload_failed": "網絡上傳失敗",
    "network_timeout": "網絡超時",
    "network_connect_failed": "網絡連接失敗",
    "network_error": "網絡錯誤",
    "pin_top": "置頂",
    "pinned_message": "置頂了消息",
    "operate_pin_in_detail": "置頂功能請在詳情頁操作",
    "pin_success": "置頂成功",
    "pin_comment": "置頂評論",
    "but_is": "而是",
    "contact_support": "聯繫客服",
    "contact_phone": "聯繫電話",
    "alliance": "聯營",
    "alliance_price": "聯營價",
    "alliance_showcase": "聯營櫥窗",
    "alliance_is_good": "聯營真好啊",
    "alliance_self_buy_price": "聯營自購價",
    "background": "背景",
    "background_image": "背景圖",
    "background_image_alt": "背景圖片",
    "victory_in_sight": "勝利在望",
    "auto_join_your_territory": "自動加入你的領地",
    "auto_login_failed": "自動登錄失敗",

    "customize": "自定義",
    "custom_loading_state": "自定義加載狀態",
    "custom_legend": "自定義圖例",
    "custom_image_preview": "自定義圖片預覽",
    "custom_navbar": "自定義導航欄",
    "custom_indicator": "自定義指示器",
    "custom_time": "自定義時間",
    "custom_type": "自定義類型",
    "custom_error_hint": "自定義錯誤提示",
    "self_earn_commission_reward": "自己也會獲得的對應傭金獎勵",
    "pickup": "自提",
    "pickup_time_select": "自提時間選擇",
    "pickup_code": "自提碼",
    "self_buy_save_money": "自購省錢",
    "to_range": "至",
    "porn": "色情",
    "node": "節點",
    "node_get_failed": "節點獲取失敗",
    "if_problem_not_solved": "若您的問題尚未解決",
    "if_phone_not_registered": "若該手機號未註冊",
    "if_need_recharge_invoice": "若需要充值發票",
    "honor_market_open_failed": "榮耀市場打開失敗",
    "honor_market_timeout": "榮耀市場超時",
    "obtain": "獲取",
    "obtain_location_failed": "獲取位置失敗",
    "obtain_location_permission_failed": "獲取位置權限失敗",
    "obtain_share_domain_failed": "獲取分享功能變數名稱失敗",
    "obtain_dynamic_param_error": "獲取動態參數錯誤",
    "obtain_district_data_failed": "獲取區縣數據失敗",
    "obtain_after_sales_reason_failed": "獲取售後理由失敗",
    "obtain_image_data_failed": "獲取圖像數據失敗",
    "obtain_city_data_failed": "獲取城市數據失敗",
    "obtain_suncode_failed": "獲取太陽碼失敗",
    "obtain_phone_failed": "獲取手機號失敗",
    "obtain_data_failed": "獲取數據失敗",
    "obtain_time": "獲取時間",
    "obtain_detail": "獲取明細",
    "failed_to_obtain_user_information": "獲取用戶資訊失敗",
    "obtained_of": "獲取的",
    "obtain_street_data_failed": "獲取街道數據失敗",
    "obtain_bank_list_failed": "獲取銀行列表失敗",
    "obtain_navigator_id": "獲取領航員數字身份",
    "obtain_verify_code": "獲取驗證碼",
    "obtain_profit_share": "獲得分潤",
    "obtain_higher_commission": "獲得更高傭金",
    "got_liked": "獲贊",
    "caidekuai": "菜得快",
    "caidekuai_dish": "菜得快現炒尖椒蛙拌麵",
    "feige": "菲鴿",
    "business_open": "營業中",
    "business_license": "營業執照",
    "business_hours": "營業時間",
    "business_hours_picker": "營業時間選擇器彈窗",
    "business_status_time": "營業狀態和時間",
    "collection": "藏品",
    "collection_name": "藏品名稱",
    "collection_hash": "藏品哈希值",
    "collection_total_value_alt": "藏品總價值",
    "collection_story": "藏品故事",
    "collection_certificate": "藏品證書",
    "xietta": "蟹太太",
    "row": "行",
    "row_auto_scroll": "行自動無縫上滑",
    "street_list": "街道列表",
    "street_level": "街道級別",
    "supplementary_desc": "補充描述",
    "awakened": "被喚醒",
    "liked_passive": "被點贊",
    "decoration_package": "裝飾包裹",
    "xicheng_district": "西城區",
    "spec_select": "規格選擇",
    "spec_select_component": "規格選擇組件",
    "spec_options": "規格選項",
    "video_upload_timeout": "視頻上傳超時",
    "video_no_face": "視頻中無有效人臉",
    "video_content": "視頻內容",
    "video_area": "視頻區域",
    "video_play_icon": "視頻播放圖標",
    "video_format_invalid": "視頻格式不滿足要求",
    "video_detail": "視頻詳情",
    "badge_display": "角標顯示",
    "solve_problems_fast": "解決問題快",
    "parse": "解析",
    "parse_upload_response_failed": "解析上傳響應失敗",
    "parse_response_failed": "解析響應失敗",
    "unlock_exclusive_rights": "解鎖專屬權益",
    "unlock_merchant_privilege_digit": "解鎖商家聯營特權與限量數字",
    "unlock_merchant_privilege_collection": "解鎖商家聯營特權與限量數字藏品",
    "trigger_wechat_phone_login": "觸發微信獲取手機號登錄",
    "trigger_button": "觸發按鈕",
    "order_info": "訂單資訊",
    "order_list": "訂單列表",
    "order_list_content": "訂單列表內容",
    "order_no_not_exist": "訂單號不存在",
    "order_remark": "訂單備註",
    "order_total_and_action": "訂單總價和操作",
    "order_total_amount": "訂單總金額",
    "order_payment": "訂單支付",
    "order_count": "訂單數",
    "order_number": "訂單編號",
    "order_detail": "訂單詳情",
    "order_amount": "訂單金額",
    "auth_and_digital_assets": "認證以及數字資產",
    "auth_info_error": "認證資訊有誤",
    "auth_failed": "認證失敗",
    "auth_success": "認證成功",
    "after_auth_success": "認證成功後",
    "auth_type": "認證類型",
    "auth_desc": "認證說明",
    "make_you_prettiest_boy": "讓你成為最靚的仔",
    "set_as_default": "設為默認",
    "set_as_default_shipping_address": "設為默認收貨地址",
    "device_download": "設備下載",
    "settings": "設置",
    "set_as_member": "設置為成員",
    "set_success": "設置成功",
    "set_admin": "設置管理員",
    "design_draft": "設計稿",
    "certificate_content_area": "證書內容區域",
    "id_card_portrait_side": "證件人像面",
    "id_card_number": "證件號碼",
    "id_card_national_emblem_side": "證件國徽面",
    "id_card_validity_type": "證件有效期類型",
    "id_card_type": "證件類型",
    "evaluate": "評價",
    "score": "評分",
    "score_number": "評分數字",
    "score_star": "評分星星",
    "score_row": "評分行",
    "comment": "評論",
    "comment_and_reply": "評論與回復",
    "commented_your_moment": "評論了你的動態",
    "comment_content": "評論內容",
    "comment_list_scroll_container": "評論列表滾動容器",
    "comment_area": "評論區",
    "comment_deleted": "評論已刪除",
    "comment_button": "評論按鈕",
    "comment_action": "評論操作",
    "comment_count": "評論數",
    "comment_body": "評論正文",
    "comment_user_avatar": "評論用戶頭像",
    "recognize": "識別",
    "recognize_failed": "識別失敗",
    "recognize_success": "識別成功",
    "word_cloud_chart": "詞雲圖",
    "product_not_in_selection_library": "該商品暫未加入你的選品庫",
    "user_account_cancelled": "該用戶已註銷",
    "spec_out_of_stock": "該規格暫無庫存",
    "territory_deleted": "該領地已刪除",
    "detail": "詳情",
    "detailed_address": "詳細地址",
    "detailed_address_info": "詳細地址資訊",
    "say_something": "說點什麼",
    "please_upload_id_card": "請上傳身份證件圖片",
    "please_scroll_read_protocol": "請下滑閱讀協議後繼續",
    "please_download": "請下載",
    "please_download_amap": "請下載高德地圖",
    "please_use": "請使用",
    "please_use_app_or_miniapp": "請使用原生應用或小程式",
    "please_recharge_and_retry": "請充值後再次重試",
    "please_upload_back_image_first": "請先上傳反面圖片",
    "please_upload_image_first": "請先上傳圖片",
    "please_negotiate_with_merchant_first": "請先與商家協商一致",
    "please_complete_real_name_auth_first": "請先完成實名認證",
    "please_login_first": "請先登錄",
    "please_check_in_personal_wallet": "請到個人錢包查看",
    "please_update_app_version": "請到應用市場更新最新版本進行正常使用",
    "please_open_in_wechat": "請到微信內打開鏈接",
    "please_go_to_settings_enable": "請前往設置開啟",
    "dont_believe_brushing": "請勿輕信刷單",
    "please_consult_territory": "請諮詢領地",
    "please_select_location_in_list": "請在下方列表中選擇位置",
    "please_pay_in_wechat_browser": "請在微信瀏覽器支付",
    "please_enable_calendar_permission_in_settings": "請在設置中開啟日曆權限",
    "please_enable_permission_in_settings": "請在設置中開啟權限",
    "please_fill_address": "請填寫地址",
    "please_fill_name": "請填寫姓名",
    "please_fill_phone": "請填寫手機號",
    "please_fill_detailed_address": "請填寫詳細地址",
    "please_wait_patiently": "請您耐心等待",
    "please_fill_manually": "請手動填寫",
    "please_open_location_permission": "請打開位置權限",
    "please_participate_on_time": "請按時參與活動",
    "please_change_here": "請改這裡",
    "please_check_and_resubmit": "請檢查後重新提交",
    "please_check_permission": "請檢查權限",
    "please_check_network": "請檢查網絡",
    "please_check_network_retry": "請檢查網絡後重試",
    "please_check_network_or_contact_admin": "請檢查網絡或聯繫管理員",
    "please_check_network_or_config": "請檢查網絡或配置",
    "please_check_network_connection": "請檢查網絡連接",
    "request_error": "請求出錯",
    "request_send_failed": "請求發送失敗",
    "request_send_exception": "請求發送異常",
    "request_send_success": "請求發送成功",
    "request_timeout": "請求超時",
    "invalid_request": "請求錯誤",
    "please_note_traffic": "請注意流量",
    "please_click": "請點擊",
    "please_click_button_operate": "請點擊下方按鈕進行操作",
    "please_click_retry": "請點擊重試",
    "please_retry_later": "請稍後重試",
    "please_wait": "請稍等",
    "please_bind_view_message": "請綁定後查看消息",
    "please_wait_patiently_alt": "請耐心等待",
    "please_wait_merchant_process": "請耐心等待商家處理",
    "please_keep_at_least_one_product": "請至少保留一個商品",
    "please_retry_after_purchase": "請購買後再次重試",
    "please_input": "請輸入",
    "please_input_content": "請輸入內容",
    "please_input_merchant_name": "請輸入商戶名稱",
    "please_input_name": "請輸入姓名",
    "please_input_bank_card_no": "請輸入開戶行卡號",
    "please_input_bank_name": "請輸入開戶行名稱",
    "please_input_tracking_no": "請輸入快遞單號",
    "please_input_nickname": "請輸入您的昵稱",
    "please_input_real_name": "請輸入您的真實姓名",
    "please_input_signature": "請輸入您的簽名",
    "please_input_phone": "請輸入信箱",
    "please_input_holder_address": "請輸入持證人詳細地址",
    "please_input_withdraw_amount": "請輸入提現金額",
    "please_input_search_content": "請輸入搜索內容",
    "please_input_correct_info": "請輸入正確資訊",
    "please_input_correct_phone": "請輸入正確的手機號",
    "please_input_real_name_alt": "請輸入真實姓名",
    "please_input_auth_desc": "請輸入認證說明",
    "please_input_id_card_no": "請輸入證件號碼",
    "please_input_detailed_address": "請輸入詳細地址",
    "please_input_id_number": "請輸入身份證號",
    "please_input_invite_code": "請輸入邀請碼",
    "please_input_bank_phone": "請輸入銀行預留手機號",
    "please_input_store_name": "請輸入門店名稱",
    "please_input_store_phone": "請輸入門店電話",
    "please_input_store_manager": "請輸入門店負責人",
    "please_input_reserved_phone": "請輸入預留手機號",
    "please_input_verify_code": "請輸入驗證碼",
    "please_return_home_buy": "請返回個人主頁購買",
    "please_select": "請選擇",
    "please_select_payment_method": "請選擇付款方式",
    "please_select_send_location": "請選擇發送位置",
    "please_select_pickup_time": "請選擇取貨時間",
    "please_select_after_sales_product": "請選擇可售後的商品",
    "please_select_product": "請選擇商品",
    "please_select_merchant_location": "請選擇商戶所在地",
    "please_select_region": "請選擇地區",
    "please_select_city": "請選擇城市",
    "please_select_complete_address": "請選擇完整的地址資訊",
    "please_select_start_time": "請選擇開始時間",
    "please_select_bank_address": "請選擇開戶行地址",
    "please_select_bank_province": "請選擇開戶行所在省",
    "please_select_bank": "請選擇開戶銀行",
    "please_select_delete_product": "請選擇想要刪除的商品",
    "please_select_holder_id_type": "請選擇持證人證件類型",
    "please_select_shipping_address": "請選擇收貨地址",
    "please_select_time": "請選擇時間",
    "please_select_validity_type": "請選擇有效期類型",
    "please_select_logistics_company": "請選擇物流公司",
    "please_select_pcd_street": "請選擇省市區街道",
    "please_select_end_time": "請選擇結束時間",
    "please_select_bg_image": "請選擇背景圖",
    "please_select_business_hours": "請選擇營業時間",
    "please_select_spec": "請選擇規格",
    "please_select_id_validity_start": "請選擇證件有效期開始時間",
    "please_select_id_validity_type": "請選擇證件有效期類型",
    "please_select_id_validity_end": "請選擇證件有效期結束時間",
    "please_select_buy_option": "請選擇購買選項",
    "please_select_store_type": "請選擇門店業態",
    "please_select_store_location": "請選擇門店位置",
    "please_relogin": "請重新登錄",
    "please_retry": "請重試",
    "please_long_press_save": "請長按圖片保存",
    "please_read_and_agree": "請閱讀並同意",
    "please_read_and_agree_protocol": "請閱讀並同意已下協議",
    "call_failed": "調用失敗",
    "call_success": "調用成功",
    "invoke_payment_method": "調起支付方式",
    "beware_scams": "謹防上當受騙",
    "manager_info": "負責人資訊",
    "contribution_value": "貢獻值",
    "contribution_detail": "貢獻值詳情",
    "contribution_is_ownership": "貢獻即確權",
    "bill": "賬單",
    "account_balance_insufficient": "賬戶可用餘額不足",
    "goods_status": "貨物狀態",
    "goods_status_modal": "貨物狀態選擇彈窗",
    "buy": "購買",
    "buy_my_shared_product": "購買了我分享的商品",
    "buy_feature_developing": "購買功能開發中",
    "after_buy": "購買後",
    "buy_only_support_use": "購買後僅支持使用",
    "auto_equip_frame_after_buy": "購買後自動佩戴此頭像框",
    "buy_product_exception": "購買商品異常時",
    "buy_avatar_frame": "購買頭像框",
    "buy_success": "購買成功",
    "buy_specified_product_claim": "購買指定商品即可領取",
    "buy_button": "購買按鈕",
    "buy_digital_rights_join_territory": "購買數字權益資產並加入領地",
    "buy_digital_asset_auth_limit": "購買數字資產以及啟動分銷員權限需完成實名認證",
    "buy_digital_asset": "購買數資",
    "buy_digital_rights_get_tasks": "購買此數字權益資產後可完成以下任務",
    "buy_digital_rights_get_distribution": "購買此數字權益資產後可獲得以下商品分銷權",
    "buy_digital_rights_get_rights": "購買此數字權益資產後可獲得以下權益",
    "buy_confirm": "購買確認",
    "buy_options": "購買選項",
    "purchase_notes": "購買須知",
    "buy_ling_point": "購買領點",
    "buy_navigator": "購買領航員",
    "shopping_coupon": "購物券",
    "shopping_cart": "購物車",
    "cart_empty": "購物車為空",
    "cart_modal": "購物車彈窗",
    "assets": "資產",
    "asset_authentication": "資產確權",
    "profile_update_failed": "資料修改失敗",
    "profile_update_success": "資料修改成功",
    "after_profile_complete": "資料全部完善後",
    "profile_completion": "資料完成度",
    "resource_ability_monetization": "資源與能力自由變現",
    "resource_ability_digitization": "資源能力數字化",
    "qualification_info": "資質資訊",
    "empower_individual": "賦能個人",
    "earn": "賺",
    "earned": "賺了",
    "earn_more_rewards": "賺取更多獎勵",
    "thumbs_up": "贊",
    "liked_your_moment": "贊了你的動態",
    "liked_your_comment": "贊了你的評論",
    "people_who_liked": "贊過的人",
    "people_who_liked_modal": "贊過的人彈框",
    "gift_item": "贈品",
    "gift_amount": "贈送款",
    "gift_white_clam_message": "贈送白蜆蝶數字資產消息",
    "from_price": "起",
    "super_value_price": "超值價",
    "super_value_coupon": "超值優惠券",
    "timeout_unpaid": "超時未支付",
    "distance_from_you": "距你",
    "distance_from_you_honor": "距您",
    "distance_greater_than": "距您大於",
    "distance": "距離",
    "distance_filter_item": "距離區域篩選項",
    "follow_buy_count": "跟買人數",
    "follow_buy_count_tag": "跟買人數標籤",
    "follow_gesture": "跟隨手勢",
    "jump_failed": "跳轉失敗",
    "identity_info_error": "身份資訊有誤",
    "identity_mark": "身份標識",
    "id_card": "身份證",
    "id_card_upload": "身份證上傳",
    "id_document_upload": "身份證件上傳",
    "id_document_image": "身份證件圖片",
    "id_info": "身份證資訊",
    "id_info_form": "身份證資訊表單",
    "id_number": "身份證號",
    "id_card_photos": "身份證正反面照片",
    "after_transform": "轉換後",
    "manage_community_easily": "輕鬆運營你的社群",
    "glory_peak_arrival": "輝煌的頂峰即將抵達",
    "input_must_be_number": "輸入必須為數字",
    "input_phone": "輸入手機號",
    "input_sms_user_pass": "輸入短信中的用戶名與密碼",
    "input_id_info": "輸入證件資訊",
    "input_amount_exceed_balance": "輸入金額超出可提現金額",
    "input_verify_code": "輸入驗證碼",
    "influencer_recommending": "達人在推薦",
    "influencer_recommend": "達人推薦",
    "refund_if_expired": "過期退",
    "freight": "運費",
    "freight_coupon": "運費券",
    "transporting": "運輸中",
    "transport_status_card": "運輸狀態卡片",
    "back": "返回",
    "return_data_format_error": "返回數據格式錯誤",
    "back_home": "返回首頁",
    "no_one_commented_yet": "還沒有人發表過評論",
    "this_guy_is_lazy": "這傢伙很懶",
    "this_is_active_interaction": "這是一個通過積極互動",
    "symbol_of_identity_status": "這是你在社區中身份與地位的象徵",
    "here_is_barren": "這裡一片荒蕪",
    "enter_homepage": "進入主頁",
    "enter_homepage_arrow": "進入主頁箭頭",
    "enter_territory": "進入領地",
    "enter_shop": "進店",
    "enter_shop_button": "進店按鈕",
    "visit_shop": "進店逛逛",
    "progress_indicator": "進度指示器",
    "perform_operation": "進行操作",
    "manage_store": "進行門店管理",
    "connection_error": "連接出錯",
    "connection_line": "連接線",
    "logout_alt": "退出登錄",
    "return_back": "退回",
    "refund": "退款",
    "refunding": "退款中",
    "refund_info": "退款資訊",
    "refund_product_info": "退款商品資訊",
    "refund_failed": "退款失敗",
    "refund_closed": "退款已關閉",
    "refund_success": "退款成功",
    "refund_no_fee": "退款無需支付手續費",
    "refund_time": "退款時間",
    "refund_reason": "退款理由",
    "refund_reason_modal": "退款理由彈窗",
    "refund_apply_failed": "退款申請失敗",
    "refund_apply_submitted": "退款申請已提交",
    "refund_progress": "退款進度",
    "refund_amount": "退款金額",
    "return_refund": "退貨退款",
    "exclusive_rights_for_you": "送給你的專屬權益",
    "applicable_shop": "適用店舖",
    "applicable_store": "適用門店",
    "adapt_notch_screen": "適配劉海屏",
    "selection_square": "選品廣場",
    "selection_library": "選品庫",
    "selection_cart": "選品車",
    "optional_field": "選填",
    "selection_done": "選好了",
    "select": "選擇",
    "select_coupon": "選擇優惠券",
    "select_location_failed": "選擇位置失敗",
    "select_birth_date": "選擇出生日期",
    "select_after_sales_info": "選擇售後資訊",
    "select_after_sales_reason": "選擇售後原因",
    "select_after_sales_product": "選擇售後商品",
    "select_after_sales_reason_alt": "選擇售後理由",
    "select_product": "選擇商品",
    "select_product_image": "選擇商品圖片",
    "select_merchant": "選擇商家",
    "select_image_failed": "選擇圖片失敗",
    "select_region": "選擇地區",
    "select_city": "選擇城市",
    "select_start_time": "選擇開始時間",
    "select_bank_address": "選擇開戶行地址",
    "select_gender": "選擇性別",
    "select_shipping_address": "選擇收貨地址",
    "select_date": "選擇日期",
    "select_validity_type": "選擇有效期類型",
    "select_status": "選擇狀態",
    "select_end_time": "選擇結束時間",
    "select_goods_status": "選擇貨物狀態",
    "select_bank_card": "選擇銀行卡",
    "select_store_type": "選擇門店業態",
    "select_territory_bg": "選擇領地背景",
    "select_territory_bg_image": "選擇領地背景圖",
    "transparent": "透明",
    "transparent_mask": "透明蒙層",
    "usually_an_image": "通常是一個圖片",
    "via_nft_issue_community": "通過數字藏品發行與社群運營",
    "traverse_comment_list": "遍歷評論列表",
    "mask_layer": "遮罩層",
    "avoid_being": "避免被",
    "invite": "邀請",
    "inviter_avatar": "邀請人頭像",
    "inviter_is_merchant": "邀請人是商家",
    "inviter_is_user": "邀請人是用戶",
    "inviter_nickname": "邀請人昵稱",
    "invite_you_join": "邀請你加入",
    "invite_you_join_territory": "邀請你加入領地",
    "invite_you_play_territory": "邀請你來領地玩",
    "invite_graph": "邀請關係圖",
    "invite_card": "邀請卡片",
    "invite_friends": "邀請好友",
    "invite_friends_share_card": "邀請好友分享卡片",
    "invite_friends_join_community": "邀請好友加入社群",
    "invite_friends_join_territory": "邀請好友加入領地",
    "invite_friends_button": "邀請好友按鈕",
    "person_who_invited_me": "邀請我的人",
    "invite_hint": "邀請提示",
    "invite_user_card_template": "邀請用戶卡片範本",
    "invite_code": "邀請碼",
    "invite_code_not_exist": "邀請碼不存在",
    "invite_code_empty": "邀請碼為空",
    "invite_code_copied": "邀請碼已複製",
    "invite_code_copied_clipboard": "邀請碼已複製到剪貼板",
    "partially_used": "部分使用",
    "partially_shipped": "部分發貨",
    "partially_batch_event_failed": "部分批量事件發送失敗",
    "everyone_has_territory": "都有自己的領地",
    "make_territory_prosperous": "都讓領地更繁榮",
    "config": "配置",
    "config_updated": "配置已更新",
    "config_update": "配置更新",
    "delivery_method_switch": "配送方式切換",
    "pub": "酒吧",
    "adopt": "採用",
    "overlapping_avatars": "重疊的頭像",
    "chongqing_impression_city": "重慶印象城",
    "chongqing_city": "重慶市",
    "rejoin_queue": "重新加入隊列",
    "resend": "重新發送",
    "repay": "重新支付",
    "retry": "重試",
    "retry_too_many_times": "重試次數過多",
    "amount_info": "金額資訊",
    "amount_display": "金額展示",
    "amount_show": "金額顯示",
    "lobster_supreme": "金鰲蝦至尊",
    "wallet_address": "錢包地址",
    "diamond": "鑽",
    "diamond_alt": "鑽石",
    "diamond_navigator": "鑽石領航員",
    "bank_card_upload": "銀行卡上傳",
    "bank_card_doc_upload": "銀行卡件上傳",
    "bank_card_info": "銀行卡資訊",
    "bank_card_form": "銀行卡資訊表單",
    "bank_card_front": "銀行卡正面",
    "mint_date": "鑄造日期",
    "chain_address": "鏈上地址",
    "link_empty": "鏈接為空",
    "link_failed": "鏈接失敗",
    "link_copied": "鏈接已複製",
    "link_copied_clipboard": "鏈接已複製到剪貼板",
    "link_generating": "鏈接生成中",
    "sales_volume": "銷量",
    "sales_over": "銷量超",
    "error": "錯誤",
    "error_banner": "錯誤提示橫幅",
    "error_state": "錯誤狀態",
    "length_exceed_limit": "長度超過限制",
    "long_press_qrcode": "長按二維碼",
    "long_press_modal": "長按彈窗組件",
    "long_press_view_detail": "長按查看詳情",
    "long_press_recognize": "長按識別",
    "long_term": "長期",
    "long_term_valid": "長期有效",
    "long_term_no_end_time": "長期有效期無需選擇結束時間",
    "changsha_city": "長沙市",
    "store": "門店",
    "store_type": "門店業態",
    "store_type_picker": "門店業態選擇器彈窗",
    "store_location": "門店位置",
    "store_info": "門店資訊",
    "store_info_display": "門店資訊展示",
    "store_settle_in": "門店入駐",
    "store_card_template": "門店卡片範本",
    "store_name": "門店名稱",
    "store_image": "門店圖片",
    "store_desc": "門店描述",
    "store_activity": "門店活動",
    "store_phone": "門店電話",
    "store_manager": "門店負責人",
    "store_selection_square": "門店選品廣場",
    "prevent_content_blocked_navbar": "防止內容被導航欄遮擋",
    "nearby_places_list": "附近地點列表",
    "downgrade_to_myapp": "降級到應用寶",
    "downgrade_button": "降級按鈕",
    "limit": "限制",
    "limit_dine_in": "限堂食",
    "limited": "限定",
    "flash_sale": "限時搶購",
    "limited_time_offer": "限時特惠",
    "purchase_limit": "限購",
    "limited_quantity": "限量",
    "limited_sale": "限量發售",
    "limited_new_product": "限量新品",
    "use_freely": "隨便用",
    "refund_anytime": "隨時退",
    "privacy_protocol": "隱私協議",
    "privacy_policy": "隱私政策",
    "hide": "隱藏",
    "hide_render": "隱藏渲染",
    "gathered_people": "集齊人數",
    "retail": "零售",
    "retail_product_detail": "零售商品詳情",
    "retail_confirm_order": "零售確認訂單",
    "retail_order_detail": "零售訂單詳情",
    "retail_detail": "零售詳情",
    "radar_chart": "雷達圖",
    "demand_match": "需求速配",
    "need_calendar_permission_add_reminder": "需要日曆權限才能添加預約提醒",
    "need_calendar_permission_add_reminder_alt": "需要日曆權限來添加預約提醒",
    "need_album_permission_save_image": "需要相冊權限才能保存圖片",
    "need_self_obtain": "需要自行獲取",
    "need_location_permission": "需要獲取您的位置權限",
    "non_distributor_status": "非分銷員狀態",
    "non_miniapp_show_cart": "非小程式環境顯示選品車入口",
    "expect_interesting_stories": "非常期待今天能和朋友們發生一些有趣的故事和互動",
    "placeholder_non_wechat_or_unready": "非微信內或未就緒時的占位",
    "show_only_non_wechat": "非微信環境才顯示",
    "non_express_order": "非快遞訂單",
    "non_business_hours": "非營業時間",
    "non_auth_digital_product_user_info_none": "非認證和數字商品類型以及用戶資訊無",
    "panel": "面板",
    "page_content": "頁面內容",
    "page_loading_state": "頁面加載狀態",
    "page_header": "頁面頭部",
    "page_starts_rendering": "頁面開始渲染",
    "page_visit": "頁面訪問",
    "top_switch_bar": "頂部切換欄",
    "top_area": "頂部區域",
    "top_avatar_blessing": "頂部頭像和祝福",
    "top_navbar": "頂部導航欄",
    "top_recommend_area": "頂部推薦區域",
    "top_text": "頂部文字",
    "top_bg_card": "頂部背景卡片",
    "top_custom_navbar": "頂部自定義導航欄",
    "top_decoration_bg": "頂部裝飾背景",
    "top_invite_text": "頂部邀請文字",
    "notice": "須知",
    "estimated": "預估",
    "estimated_commission": "預估傭金",
    "estimated_commission_modal": "預估傭金說明彈窗",
    "estimated_revenue": "預估收益",
    "estimated_max_earn": "預估最高賺",
    "reserved_phone": "預留手機號",
    "reservation_person": "預約人",
    "reservation_count": "預約人數",
    "reservation_success": "預約成功",
    "reservation_rank": "預約排行榜",
    "reservation_ranking": "預約榜",
    "estimated_discount": "預計優惠",
    "estimated_commission_total": "預計已售賣且可分傭訂單確認收貨或核銷後可賺傭金總額",
    "lord": "領主",
    "claim": "領取",
    "claim_exclusive_welfare": "領取你的專屬福利",
    "claim_exclusive_red_packet": "領取你的專屬紅包",
    "claim_list": "領取列表",
    "after_claim": "領取後",
    "claim_reward_success": "領取獎勵成功",
    "claim_success": "領取成功",
    "claim_button": "領取按鈕",
    "claim_status": "領取狀態",
    "claim_territory_id_join": "領取領地數字身份並加入領地",
    "territory": "領地",
    "territory_intro": "領地介紹",
    "territory_task": "領地任務",
    "territory_info": "領地資訊",
    "territory_value": "領地值",
    "territory_share_card": "領地分享卡片",
    "territory_share_modal": "領地分享彈窗",
    "territory_distribution_class": "領地分銷課堂",
    "territory_list": "領地列表",
    "territory_moment": "領地動態",
    "territory_card_template": "領地卡片範本",
    "territory_create_success": "領地即可創建成功",
    "territory_unveil_soon": "領地即將揭幕",
    "territory_original": "領地原創",
    "territory_no": "領地號",
    "territory_name": "領地名稱",
    "territory_start": "領地啟程",
    "territory_avatar": "領地頭像",
    "territory_service": "領地客服",
    "territory_square": "領地廣場",
    "territory_member": "領地成員",
    "territory_member_count": "領地成員數",
    "territory_member_tag": "領地成員標籤",
    "territory_phone": "領地手機號",
    "territory_checkin_miss_you": "領地打卡就差你啦",
    "territory_promise_privacy": "領地承諾絕不使用或洩露您的實名資訊",
    "territory_guide": "領地指南",
    "territory_search": "領地搜索",
    "territory_nft_mall": "領地數字藏品商城",
    "territory_data": "領地數據",
    "territory_showcase": "領地櫥窗",
    "territory_activity": "領地活動",
    "territory_user": "領地用戶",
    "territory_no_self_create": "領地目前不支持自主創建",
    "territory_code": "領地碼",
    "territory_selection": "領地精選",
    "territory_alliance": "領地聯營",
    "territory_bg_image": "領地背景圖",
    "territory_bg_preview": "領地背景預覽",
    "territory_help_user": "領地致力於幫助用戶",
    "territory_settings": "領地設置",
    "territory_detail": "領地詳情",
    "territory_contribution": "領地貢獻值",
    "territory_notice": "領地通知",
    "territory_channel": "領地頻道",
    "claim_reward": "領獎勵",
    "ling_point": "領點",
    "ling_point_balance": "領點餘額",
    "ling_point_deduction": "領點抵扣",
    "ling_point_deduction_display": "領點抵扣展示",
    "ling_point_deducted": "領點抵扣已減",
    "ling_point_red_packet": "領點紅包",
    "ling_point_earn_nonstop": "領點賺不停",
    "ling_point_page": "領點頁面組件",
    "navigator": "領航員",
    "navigator_digital_asset_order": "領航員數字資產訂單",
    "navigator_digital_identity": "領航員數字身份",
    "navigator_earn_per_order": "領航員每單可賺",
    "ling_diamond": "領鑽",
    "ling_diamond_balance": "領鑽餘額",
    "ling_diamond_insufficient": "領鑽餘額不足",
    "ling_diamond_recharge": "領鑽充值",
    "ling_diamond_mall": "領鑽商城",
    "ling_diamond_red_packet": "領鑽紅包",
    "ling_diamond_buy_protocol": "領鑽購買協議",
    "channel_pin_top": "頻道置頂",
    "stars_count": "顆星星",
    "color_extract_failed": "顏色提取失敗",
    "pie_chart": "餅狀圖",
    "first_post_interaction": "首發帖在線求互動",
    "first_asset": "首發資產",
    "homepage": "首頁",
    "show_at_homepage": "首頁時顯示",
    "open_red_packet_now": "馬上拆紅包",
    "verify_not_same_person": "驗證不是同一個人",
    "verify_code_sent": "驗證碼已發送",
    "skeleton_loading": "骨架屏加載狀態",
    "height_fixed": "高度固定",
    "efficient_management_tool": "高效管理工具",
    "gold_navigator": "黃金領航員",
    "default": "默認",
    "default_is": "默認為",
    "default_group": "默認分組",
    "default_search_icon": "默認搜索圖標",
    "default_title": "默認標題",
    "default_gift": "默認禮物",
    "default_empty_template": "默認空白範本",
    "default_back_button": "默認返回按鈕",
    "land_activity": "領地活動",
    "land_shop_window": "領地櫥窗",
    "land_store": "門店",
    "land_no_store": "暫無門店",
    "land_demand_match": "需求速配",
    "land_ido_square": "IDO廣場",
    "land_initial_assets": "首發資產",
    "land_connection_count_suffix": "條人脈",

    // 發佈動態頁面
    "publish_dynamic": "發布動態",
    "publish": "發布",
    "publishing": "發布中",
    "publish_success": "發布成功",
    "add_title": "添加標題",
    "add_content": "添加正文",
    "link_territory": "關聯領地",
    "select_activity_product_store": "選擇活動/商品/門店",
    "no_activity_product_store_found": "未找到活動/商品/門店",
    "get_more_rewards": "獲得更多收益",
    "discard_edit_confirm": "是否放棄編輯？",
    "select_territory_developing": "選擇領地功能開發中",
    "select_activity_developing": "選擇活動功能開發中",

    // 選擇地點頁面
    "search_location": "搜索地點",
    "locating": "定位中",
    "location_failed": "定位失敗",
    "searching": "搜索中",
    "please_select_location": "請選擇地點",
    "location_permission_required": "需要位置權限",
    "location_permission_desc": "為了提供更好的服務，需要獲取您的位置資訊。請在瀏覽器設置中允許訪問位置。",
    "go_to_settings": "去設置",
    "use_default_location": "使用默認位置",
    "please_enable_location_in_browser": "請在瀏覽器設置中開啟位置權限",
    "login_to_open_red_packet": "登錄後，馬上拆紅包",
    "auto_register_if_not_registered": "若該手機號未註冊,我們將自動為您註冊",
    "code_sent_to": "已發送至",
    "cannot_login_try_again": "無法登錄？再試一次",
    "please_input_4_digit_code": "請輸入4位數字驗證碼",
    "send_failed_retry": "發送失敗，請重試",
    "user_agreement_territory": "用戶協議(領地)",
    "user_agreement_territory_bracket": "《用戶協議(領地)》",
    "user_privacy_agreement_territory": "用戶隱私協議(領地)",
    "user_privacy_agreement_territory_bracket": "《用戶隱私協議(領地)》",
    "add_new_address": "新建地址",
    "home": "家",
    "get_location_failed_check_permission": "獲取位置失敗，請檢查權限",
    "need_location_permission_go_settings": "需要獲取您的位置權限，請前往設置開啟",
    "get_location_permission_failed": "獲取位置權限失敗",
    "select_country_region": "選擇國家/地區",
    "my_address": "我的地址",
    "hong_kong": "香港",
    "macau": "澳門",
    "signature_params_incomplete": "簽名參數不完整",
    "year_month_format": "YYYY年MM月",
    "after_year": "後",
    "total_n_items": "共 {n} 條",
    "get_dynamic_params_error": "獲取動態參數錯誤",
    "joined_territory": "他加入的領地",
    "check_my_homepage": "來看看我的主頁～",
    "pending_use_receipt": "待使用/待收貨",
    "pending_evaluate": "待評價",
    "insufficient_balance": "賬戶可用餘額不足",
    "rights_update_regularly": "權益定期更新",
    "and_earn_commission": "並賺取佣金",
    "and_claim_rewards": "並領取獎勵",
    "already_hold_digital_product": "已經持有該數字商品",
    "open_after": "後開啟",
    "claim_success_check_wallet": "領取成功，請到個人錢包查看",
    "login_success_paying": "登錄成功,正在支付",
    "details": "詳情",
    "joint_venture": "聯營",
    "from_territory_recommend": "來自{name}的推薦，點擊去看看吧~",
    "ido_digital_asset_order": "IDO數字資產訂單",
    "goods_service_order": "商品/服務訂單",
    "page_back_triggered": "頁面返回被觸發",
    "paid": "已支付",
    "shipping": "配送中",
    "pending": "待處理",
    "store_preparing": "店鋪籌備中",
    "pending_open_shop": "待開店",
    "store_opened": "已開店",
    "store_closed": "已閉店",
    "pending_delivery": "待發貨",
    "partial_delivery": "部分發貨",
    "partial_used": "部分使用",
    "used": "已使用",
    "expired": "已失效",
    "closed": "已關閉",
    "pending_seller_accept": "待賣家接單",
    "shopping_voucher": "購物券",
    "freight_voucher": "運費券",
    "self_pickup": "打包自提",
    "pending_merchant_confirm": "待商家確認",
    "pending_merchant_refund": "待商家退款",
    "pending_fill_logistics": "待填寫物流信息",
    "merchant_rejected_refund": "商家拒絕退款",
    "after_sales_revoked_closed": "您已撤銷售後，退款已關閉",
    "return_and_refund": "退貨退款",
    "refund_to_wechat": "退回 (微信)",
    "remark": "理由",
    "refund_request_submitted_wait": "您已成功發起退款申請，請耐心等待商家處理",
    "merchant_no_confirm_auto_refund": "後商家未確認，將自動退款",
    "merchant_no_confirm_auto_agree": "後商家未確認，將自動同意售後",
    "issue_not_resolved_reapply_after": "若您的問題尚未解決，可以在",
    "not_shipped_revoke_return": "後未寄出將撤銷退貨申請",
    "merchant_no_refund_auto_refund": "後商家未退款，將自動退款給您",
    "reapply_after_sales": "後再次申請售後",
    "cancel_revoke": "暫不撤銷",
    "revoke_after_sales_retry": "撤銷售後失敗，請稍後重試",
    "remaining_payment_time": "剩餘支付時間",
    "order_no": "訂單編號",
    "cancel_time": "取消時間",
    "you_have_points": "您當前有{count}領點",
    "use_points_deduct": "使用{points}領點抵扣{amount}$",
    "confirm_receipt_success": "確認收貨成功",
    "refunding": "退款中...",
    "refund_apply_submitted": "退款申請已提交",
    "refund_apply_failed": "退款申請失敗",
    "operation_failed_retry": "操作失敗，請重試",
    "refund_success": "退款成功",
    "refund_failed": "退款失敗",
    "select_after_sales_reason": "選擇售後原因",
    "balance_insufficient": "賬戶可用餘額不足",
    "full_amount_available": "滿{amount}$可用",
    "valid_until": "有效期至",
    "go_to_use": "去使用",
};
